var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuarantee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167.42,
    height: 167.42,
    viewBox: "0 0 167.42 167.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{opacity:0.5;}.cls-147,.cls-5{mix-blend-mode:multiply;}.cls-6{fill:#010101;}.cls-7{fill:#191918;}.cls-8{fill:#2b2a29;}.cls-9{fill:#3b3939;}.cls-10{fill:#4c4949;}.cls-11{fill:#5e5b5b;}.cls-12{fill:#726f6f;}.cls-13{fill:#888585;}.cls-14{fill:#a19e9e;}.cls-15{fill:#bbb9b8;}.cls-16{fill:#d8d6d6;}.cls-17{fill:#fff;}.cls-18{mix-blend-mode:screen;}.cls-19{fill:url(#linear-gradient-3);}.cls-20{fill:url(#linear-gradient-4);}.cls-21{fill:url(#linear-gradient-5);}.cls-22{fill:url(#linear-gradient-6);}.cls-23{fill:url(#linear-gradient-7);}.cls-24{fill:url(#linear-gradient-8);}.cls-25{fill:url(#linear-gradient-9);}.cls-26{fill:url(#linear-gradient-10);}.cls-27{fill:url(#linear-gradient-11);}.cls-28{fill:url(#linear-gradient-12);}.cls-29{fill:url(#linear-gradient-13);}.cls-30{fill:url(#linear-gradient-14);}.cls-31{fill:url(#linear-gradient-15);}.cls-32{fill:url(#linear-gradient-16);}.cls-33{fill:url(#linear-gradient-17);}.cls-34{fill:url(#linear-gradient-18);}.cls-35{fill:url(#linear-gradient-19);}.cls-36{fill:url(#linear-gradient-20);}.cls-37{fill:url(#linear-gradient-21);}.cls-38{fill:url(#linear-gradient-22);}.cls-39{fill:url(#linear-gradient-23);}.cls-40{fill:url(#linear-gradient-24);}.cls-41{fill:url(#linear-gradient-25);}.cls-42{fill:url(#linear-gradient-26);}.cls-43{fill:url(#linear-gradient-27);}.cls-44{fill:url(#linear-gradient-28);}.cls-45{fill:url(#linear-gradient-29);}.cls-46{fill:url(#linear-gradient-30);}.cls-47{fill:url(#linear-gradient-31);}.cls-48{fill:url(#linear-gradient-32);}.cls-49{fill:url(#linear-gradient-33);}.cls-50{fill:url(#linear-gradient-34);}.cls-51{fill:url(#linear-gradient-35);}.cls-52{fill:url(#linear-gradient-36);}.cls-53{fill:url(#linear-gradient-37);}.cls-54{fill:url(#linear-gradient-38);}.cls-55{fill:url(#linear-gradient-39);}.cls-56{fill:url(#linear-gradient-40);}.cls-57{fill:url(#linear-gradient-41);}.cls-58{fill:url(#linear-gradient-42);}.cls-59{fill:url(#linear-gradient-43);}.cls-60{fill:url(#linear-gradient-44);}.cls-61{fill:url(#linear-gradient-45);}.cls-62{fill:url(#linear-gradient-46);}.cls-63{fill:url(#linear-gradient-47);}.cls-64{fill:url(#linear-gradient-48);}.cls-65{fill:url(#linear-gradient-49);}.cls-66{fill:url(#linear-gradient-50);}.cls-67{fill:url(#linear-gradient-51);}.cls-68{fill:url(#linear-gradient-52);}.cls-69{fill:url(#linear-gradient-53);}.cls-70{fill:url(#linear-gradient-54);}.cls-71{fill:url(#linear-gradient-55);}.cls-72{fill:url(#linear-gradient-56);}.cls-73{fill:url(#linear-gradient-57);}.cls-74{fill:url(#linear-gradient-58);}.cls-75{fill:url(#linear-gradient-59);}.cls-76{fill:url(#linear-gradient-60);}.cls-77{fill:url(#linear-gradient-61);}.cls-78{fill:url(#linear-gradient-62);}.cls-79{fill:url(#linear-gradient-63);}.cls-80{fill:url(#linear-gradient-64);}.cls-81{fill:url(#linear-gradient-65);}.cls-82{fill:url(#linear-gradient-66);}.cls-83{fill:url(#linear-gradient-67);}.cls-84{fill:url(#linear-gradient-68);}.cls-85{fill:url(#linear-gradient-69);}.cls-86{fill:url(#linear-gradient-70);}.cls-87{fill:url(#linear-gradient-71);}.cls-88{fill:url(#linear-gradient-72);}.cls-89{fill:url(#linear-gradient-73);}.cls-90{fill:url(#linear-gradient-74);}.cls-91{fill:url(#linear-gradient-75);}.cls-92{fill:url(#linear-gradient-76);}.cls-93{fill:url(#linear-gradient-77);}.cls-94{fill:url(#linear-gradient-78);}.cls-95{fill:url(#linear-gradient-79);}.cls-96{fill:url(#linear-gradient-80);}.cls-97{fill:url(#linear-gradient-81);}.cls-98{fill:url(#linear-gradient-82);}.cls-99{fill:url(#linear-gradient-83);}.cls-100{fill:url(#linear-gradient-84);}.cls-101{fill:url(#linear-gradient-85);}.cls-102{fill:url(#linear-gradient-86);}.cls-103{fill:url(#linear-gradient-87);}.cls-104{fill:url(#linear-gradient-88);}.cls-105{fill:url(#linear-gradient-89);}.cls-106{fill:url(#linear-gradient-90);}.cls-107{fill:url(#linear-gradient-91);}.cls-108{fill:url(#linear-gradient-92);}.cls-109{fill:url(#linear-gradient-93);}.cls-110{fill:url(#linear-gradient-94);}.cls-111{fill:url(#linear-gradient-95);}.cls-112{fill:url(#linear-gradient-96);}.cls-113{fill:url(#linear-gradient-97);}.cls-114{fill:url(#linear-gradient-98);}.cls-115{fill:url(#linear-gradient-99);}.cls-116{fill:url(#linear-gradient-100);}.cls-117{fill:url(#linear-gradient-101);}.cls-118{fill:url(#linear-gradient-102);}.cls-119{fill:url(#linear-gradient-103);}.cls-120{fill:url(#linear-gradient-104);}.cls-121{fill:url(#linear-gradient-105);}.cls-122{fill:url(#linear-gradient-106);}.cls-123{fill:url(#linear-gradient-107);}.cls-124{fill:url(#linear-gradient-108);}.cls-125{fill:url(#linear-gradient-109);}.cls-126{fill:url(#linear-gradient-110);}.cls-127{fill:url(#linear-gradient-111);}.cls-128{fill:url(#linear-gradient-112);}.cls-129{fill:url(#linear-gradient-113);}.cls-130{fill:url(#linear-gradient-114);}.cls-131{fill:url(#linear-gradient-115);}.cls-132{fill:url(#linear-gradient-116);}.cls-133{fill:url(#linear-gradient-117);}.cls-134{fill:url(#linear-gradient-118);}.cls-135{fill:url(#linear-gradient-119);}.cls-136{fill:url(#linear-gradient-120);}.cls-137{fill:url(#linear-gradient-121);}.cls-138{fill:url(#linear-gradient-122);}.cls-139{fill:url(#linear-gradient-123);}.cls-140{fill:url(#linear-gradient-124);}.cls-141{fill:url(#linear-gradient-125);}.cls-142{fill:url(#linear-gradient-126);}.cls-143{fill:url(#linear-gradient-127);}.cls-144{fill:url(#linear-gradient-128);}.cls-145{fill:url(#linear-gradient-129);}.cls-146{fill:url(#linear-gradient-130);}.cls-148{clip-path:url(#clip-path);}.cls-149{clip-path:url(#clip-path-3);}.cls-150{fill:url(#linear-gradient-131);}.cls-151{fill:url(#linear-gradient-132);}.cls-152{fill:url(#linear-gradient-133);}.cls-153{fill:url(#linear-gradient-134);}.cls-154{fill:url(#linear-gradient-135);}.cls-155{fill:url(#linear-gradient-136);}.cls-156{fill:url(#linear-gradient-137);}.cls-157{fill:url(#linear-gradient-138);}.cls-158{fill:url(#linear-gradient-139);}.cls-159{fill:url(#linear-gradient-140);}.cls-160{fill:url(#linear-gradient-141);}.cls-161{fill:url(#linear-gradient-142);}.cls-162{fill:url(#linear-gradient-143);}.cls-163{fill:url(#linear-gradient-144);}.cls-164{fill:url(#linear-gradient-145);}.cls-165{fill:url(#linear-gradient-146);}.cls-166{fill:url(#linear-gradient-147);}.cls-167{fill:url(#linear-gradient-148);}.cls-168{fill:url(#linear-gradient-149);}.cls-169{fill:url(#linear-gradient-150);}.cls-170{fill:url(#linear-gradient-151);}.cls-171{fill:url(#linear-gradient-152);}.cls-172{fill:url(#linear-gradient-153);}.cls-173{fill:url(#linear-gradient-154);}.cls-174{fill:url(#linear-gradient-155);}.cls-175{fill:url(#linear-gradient-156);}.cls-176{fill:url(#linear-gradient-157);}.cls-177{fill:url(#linear-gradient-158);}.cls-178{fill:url(#linear-gradient-159);}.cls-179{fill:url(#linear-gradient-160);}.cls-180{fill:url(#linear-gradient-161);}.cls-181{fill:url(#linear-gradient-162);}.cls-182{fill:url(#linear-gradient-163);}.cls-183{fill:url(#linear-gradient-164);}.cls-184{fill:url(#linear-gradient-165);}.cls-185{fill:url(#linear-gradient-166);}.cls-186{fill:url(#linear-gradient-167);}.cls-187{fill:url(#linear-gradient-168);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40.28,
    y1: 91.76,
    x2: 158.22,
    y2: 209.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f7ec81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#eddc75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dec161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c89b46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b2752a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#b67b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c08b37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d0a648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#e7cc5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 40.68,
    y1: 92.16,
    x2: 157.83,
    y2: 209.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbf27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#febe41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fec547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ffd052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ffd758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ffd95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f8d055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e6b848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#c99033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#be812b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d09635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#e5ae3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f4bf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fcc94c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcc4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 15.49,
    y1: 117.34,
    x2: 132.64,
    y2: 234.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 62.96,
    y1: 69.88,
    x2: 180.11,
    y2: 187.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 164.15,
    y1: 148.09,
    x2: 169.57,
    y2: 153.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#be812b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcc4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 164.06,
    y1: 151.48,
    x2: 169.47,
    y2: 156.89,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 163.81,
    y1: 154.85,
    x2: 169.21,
    y2: 160.24,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 163.41,
    y1: 158.2,
    x2: 168.77,
    y2: 163.57,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 162.84,
    y1: 161.54,
    x2: 168.17,
    y2: 166.87,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 162.11,
    y1: 164.85,
    x2: 167.39,
    y2: 170.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 161.22,
    y1: 168.12,
    x2: 166.45,
    y2: 173.35,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 160.17,
    y1: 171.35,
    x2: 165.34,
    y2: 176.51,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 158.98,
    y1: 174.53,
    x2: 164.06,
    y2: 179.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 157.63,
    y1: 177.64,
    x2: 162.63,
    y2: 182.64,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 156.13,
    y1: 180.68,
    x2: 161.04,
    y2: 185.59,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 154.49,
    y1: 183.65,
    x2: 159.29,
    y2: 188.45,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 152.71,
    y1: 186.53,
    x2: 157.4,
    y2: 191.23,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 150.8,
    y1: 189.33,
    x2: 155.37,
    y2: 193.9,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 148.76,
    y1: 192.03,
    x2: 153.2,
    y2: 196.47,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 146.59,
    y1: 194.62,
    x2: 150.89,
    y2: 198.92,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 144.31,
    y1: 197.11,
    x2: 148.47,
    y2: 201.26,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 141.91,
    y1: 199.47,
    x2: 145.92,
    y2: 203.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 139.41,
    y1: 201.72,
    x2: 143.26,
    y2: 205.56,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 136.81,
    y1: 203.84,
    x2: 140.49,
    y2: 207.52,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 134.11,
    y1: 205.83,
    x2: 137.61,
    y2: 209.33,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 131.33,
    y1: 207.68,
    x2: 134.65,
    y2: 211,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 128.46,
    y1: 209.38,
    x2: 131.6,
    y2: 212.52,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 125.52,
    y1: 210.94,
    x2: 128.46,
    y2: 213.88,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 122.52,
    y1: 212.35,
    x2: 125.26,
    y2: 215.09,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 119.45,
    y1: 213.6,
    x2: 121.99,
    y2: 216.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 116.33,
    y1: 214.69,
    x2: 118.67,
    y2: 217.03,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 113.17,
    y1: 215.62,
    x2: 115.3,
    y2: 217.75,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 109.97,
    y1: 216.38,
    x2: 111.9,
    y2: 218.31,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 106.74,
    y1: 216.98,
    x2: 108.46,
    y2: 218.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 103.49,
    y1: 217.41,
    x2: 105,
    y2: 218.93,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 100.23,
    y1: 217.68,
    x2: 101.53,
    y2: 218.98,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 96.84,
    y1: 217.65,
    x2: 98.14,
    y2: 218.96,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 93.37,
    y1: 217.38,
    x2: 94.87,
    y2: 218.88,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 89.91,
    y1: 216.94,
    x2: 91.62,
    y2: 218.65,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 86.47,
    y1: 216.33,
    x2: 88.39,
    y2: 218.25,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 83.06,
    y1: 215.56,
    x2: 85.19,
    y2: 217.68,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 79.7,
    y1: 214.62,
    x2: 82.03,
    y2: 216.95,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 76.37,
    y1: 213.52,
    x2: 78.91,
    y2: 216.06,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 73.11,
    y1: 212.27,
    x2: 75.84,
    y2: 215,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 69.91,
    y1: 210.85,
    x2: 72.83,
    y2: 213.78,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 66.78,
    y1: 209.29,
    x2: 69.89,
    y2: 212.41,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 63.73,
    y1: 207.58,
    x2: 67.03,
    y2: 210.88,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 60.76,
    y1: 205.73,
    x2: 64.25,
    y2: 209.21,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 57.89,
    y1: 203.74,
    x2: 61.55,
    y2: 207.39,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 55.13,
    y1: 201.61,
    x2: 58.95,
    y2: 205.44,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 52.47,
    y1: 199.36,
    x2: 56.45,
    y2: 203.35,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 49.92,
    y1: 196.99,
    x2: 54.06,
    y2: 201.13,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 47.5,
    y1: 194.5,
    x2: 51.78,
    y2: 198.78,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 45.2,
    y1: 191.9,
    x2: 49.62,
    y2: 196.32,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 43.04,
    y1: 189.2,
    x2: 47.59,
    y2: 193.75,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 41.01,
    y1: 186.4,
    x2: 45.68,
    y2: 191.07,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 39.12,
    y1: 183.51,
    x2: 43.91,
    y2: 188.3,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 37.38,
    y1: 180.54,
    x2: 42.28,
    y2: 185.43,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 35.8,
    y1: 177.49,
    x2: 40.79,
    y2: 182.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 34.37,
    y1: 174.37,
    x2: 39.45,
    y2: 179.46,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 33.1,
    y1: 171.2,
    x2: 38.26,
    y2: 176.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 31.99,
    y1: 167.97,
    x2: 37.22,
    y2: 173.2,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 31.06,
    y1: 164.69,
    x2: 36.34,
    y2: 169.98,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 30.29,
    y1: 161.39,
    x2: 35.62,
    y2: 166.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 29.69,
    y1: 158.05,
    x2: 35.06,
    y2: 163.42,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 29.27,
    y1: 154.69,
    x2: 34.67,
    y2: 160.09,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 29.02,
    y1: 151.33,
    x2: 34.43,
    y2: 156.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 28.94,
    y1: 147.95,
    x2: 34.35,
    y2: 153.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 29.04,
    y1: 144.58,
    x2: 34.45,
    y2: 149.99,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 29.3,
    y1: 141.22,
    x2: 34.7,
    y2: 146.62,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 29.73,
    y1: 137.89,
    x2: 35.1,
    y2: 143.26,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 30.34,
    y1: 134.59,
    x2: 35.67,
    y2: 139.92,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 31.11,
    y1: 131.33,
    x2: 36.4,
    y2: 136.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 32.06,
    y1: 128.11,
    x2: 37.29,
    y2: 133.34,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 33.17,
    y1: 124.95,
    x2: 38.33,
    y2: 130.11,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 34.44,
    y1: 121.85,
    x2: 39.53,
    y2: 126.94,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 35.88,
    y1: 118.82,
    x2: 40.88,
    y2: 123.83,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 37.47,
    y1: 115.87,
    x2: 42.38,
    y2: 120.78,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 39.22,
    y1: 113.01,
    x2: 44.02,
    y2: 117.81,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 41.11,
    y1: 110.24,
    x2: 45.8,
    y2: 114.93,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 43.14,
    y1: 107.56,
    x2: 47.71,
    y2: 112.13,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 45.31,
    y1: 105,
    x2: 49.75,
    y2: 109.44,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 47.61,
    y1: 102.54,
    x2: 51.92,
    y2: 106.84,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 50.04,
    y1: 100.2,
    x2: 54.2,
    y2: 104.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 52.59,
    y1: 97.99,
    x2: 56.59,
    y2: 101.99,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 55.25,
    y1: 95.9,
    x2: 59.1,
    y2: 99.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 58.02,
    y1: 93.95,
    x2: 61.7,
    y2: 97.62,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 60.89,
    y1: 92.13,
    x2: 64.4,
    y2: 95.64,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 63.86,
    y1: 90.47,
    x2: 67.18,
    y2: 93.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 66.91,
    y1: 88.95,
    x2: 70.04,
    y2: 92.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 70.04,
    y1: 87.58,
    x2: 72.98,
    y2: 90.52,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 73.25,
    y1: 86.37,
    x2: 75.99,
    y2: 89.12,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 76.51,
    y1: 85.32,
    x2: 79.06,
    y2: 87.87,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 79.84,
    y1: 84.43,
    x2: 82.18,
    y2: 86.78,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 83.2,
    y1: 83.71,
    x2: 85.34,
    y2: 85.85,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 86.61,
    y1: 83.15,
    x2: 88.54,
    y2: 85.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 90.05,
    y1: 82.76,
    x2: 91.77,
    y2: 84.48,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 93.5,
    y1: 82.54,
    x2: 95.02,
    y2: 84.05,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 96.97,
    y1: 82.48,
    x2: 98.28,
    y2: 83.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 100.37,
    y1: 82.51,
    x2: 101.67,
    y2: 83.81,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 103.64,
    y1: 82.58,
    x2: 105.14,
    y2: 84.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 106.89,
    y1: 82.81,
    x2: 108.6,
    y2: 84.52,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 110.12,
    y1: 83.21,
    x2: 112.04,
    y2: 85.13,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 113.32,
    y1: 83.78,
    x2: 115.44,
    y2: 85.9,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 116.48,
    y1: 84.51,
    x2: 118.81,
    y2: 86.84,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 119.6,
    y1: 85.41,
    x2: 122.13,
    y2: 87.94,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 122.67,
    y1: 86.46,
    x2: 125.4,
    y2: 89.2,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 125.67,
    y1: 87.68,
    x2: 128.6,
    y2: 90.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 128.61,
    y1: 89.05,
    x2: 131.73,
    y2: 92.17,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 131.48,
    y1: 90.58,
    x2: 134.78,
    y2: 93.88,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 134.26,
    y1: 92.25,
    x2: 137.75,
    y2: 95.74,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 136.96,
    y1: 94.07,
    x2: 140.61,
    y2: 97.73,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 139.56,
    y1: 96.03,
    x2: 143.38,
    y2: 99.85,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 142.06,
    y1: 98.12,
    x2: 146.04,
    y2: 102.1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 144.45,
    y1: 100.34,
    x2: 148.58,
    y2: 104.47,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 146.72,
    y1: 102.68,
    x2: 151.01,
    y2: 106.96,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 148.88,
    y1: 105.14,
    x2: 153.31,
    y2: 109.56,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 150.92,
    y1: 107.71,
    x2: 155.47,
    y2: 112.26,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 152.82,
    y1: 110.39,
    x2: 157.5,
    y2: 115.06,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 154.6,
    y1: 113.16,
    x2: 159.39,
    y2: 117.95,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 156.23,
    y1: 116.03,
    x2: 161.12,
    y2: 120.93,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 157.72,
    y1: 118.98,
    x2: 162.71,
    y2: 123.97,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 159.06,
    y1: 122.01,
    x2: 164.14,
    y2: 127.09,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 160.25,
    y1: 125.11,
    x2: 165.41,
    y2: 130.27,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 161.28,
    y1: 128.27,
    x2: 166.51,
    y2: 133.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 162.16,
    y1: 131.48,
    x2: 167.45,
    y2: 136.77,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 162.88,
    y1: 134.74,
    x2: 168.22,
    y2: 140.08,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 163.44,
    y1: 138.04,
    x2: 168.81,
    y2: 143.41,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 163.84,
    y1: 141.37,
    x2: 169.24,
    y2: 146.77,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 164.08,
    y1: 144.73,
    x2: 169.49,
    y2: 150.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-15.54 -67.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.78,
    cy: 153.64,
    r: 3.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-15.54 -67.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.72,150.47a3.17,3.17,0,1,0,3.17,3.17A3.17,3.17,0,0,0,146.72,150.47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 58.02,
    y1: 109.5,
    x2: 140.49,
    y2: 191.96,
    gradientTransform: "translate(0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 64.1,
    y1: 102.18,
    x2: 147.82,
    y2: 185.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#595a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2c2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 21.69,
    y1: 144.59,
    x2: 105.39,
    y2: 228.3,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 23.74,
    y1: 142.54,
    x2: 107.45,
    y2: 226.24,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 56.36,
    y1: 109.92,
    x2: 140.07,
    y2: 193.63,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 91.48,
    y1: 74.79,
    x2: 175.2,
    y2: 158.5,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 48.9,
    y1: 117.38,
    x2: 132.63,
    y2: 201.11,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 44.18,
    y1: 122.1,
    x2: 127.88,
    y2: 205.8,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 23.04,
    y1: 143.25,
    x2: 106.73,
    y2: 226.94,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 57.4,
    y1: 108.88,
    x2: 141.1,
    y2: 192.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 89.94,
    y1: 76.33,
    x2: 173.65,
    y2: 160.04,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 32.81,
    y1: 133.49,
    x2: 116.5,
    y2: 217.18,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 42.04,
    y1: 124.28,
    x2: 125.72,
    y2: 207.96,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 122.08,
    y1: 195.28,
    x2: 54.23,
    y2: 127.43,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 105.17,
    y1: 212.2,
    x2: 37.32,
    y2: 144.34,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 100.91,
    y1: 216.45,
    x2: 33.07,
    y2: 148.6,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 165.29,
    y1: 152.07,
    x2: 97.44,
    y2: 84.22,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 131.93,
    y1: 185.45,
    x2: 64.06,
    y2: 117.59,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 114.99,
    y1: 202.38,
    x2: 47.13,
    y2: 134.52,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 142.52,
    y1: 174.89,
    x2: 74.64,
    y2: 107.01,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 132.32,
    y1: 184.9,
    x2: 64.68,
    y2: 117.26,
    xlinkHref: "#linear-gradient-140"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 109.47,
    y1: 207.9,
    x2: 41.6,
    y2: 140.03,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 161.82,
    y1: 155.56,
    x2: 93.96,
    y2: 87.69,
    xlinkHref: "#linear-gradient-132"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 58.02,
    y1: 109.5,
    x2: 140.49,
    y2: 191.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 9.99,
    y1: 75.02,
    x2: 92.38,
    y2: 157.41,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 18.47,
    y1: 66.54,
    x2: 100.86,
    y2: 148.92,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 57.02,
    y1: 110.55,
    x2: 139.41,
    y2: 192.94,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 75.92,
    y1: 9.1,
    x2: 158.3,
    y2: 91.48,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 30.28,
    y1: 137.3,
    x2: 112.66,
    y2: 219.68,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 90.59,
    y1: 76.98,
    x2: 172.98,
    y2: 159.37,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 86.92,
    y1: 80.65,
    x2: 169.31,
    y2: 163.04,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 54.62,
    y1: 156.47,
    x2: 48.95,
    y2: 150.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#595a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#505151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#383939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 149.56,
    y1: 156.47,
    x2: 143.89,
    y2: 150.8,
    xlinkHref: "#linear-gradient-162"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 67.69,
    y1: 99.83,
    x2: 150.16,
    y2: 182.29,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 55.82,
    y1: 111.7,
    x2: 138.28,
    y2: 194.17,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 42.37,
    y1: 125.15,
    x2: 124.84,
    y2: 207.61,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 47.37,
    y1: 120.15,
    x2: 129.84,
    y2: 202.61,
    xlinkHref: "#linear-gradient-154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 38.8,
    y1: 46.16,
    x2: 121.27,
    y2: 128.62,
    xlinkHref: "#linear-gradient-154"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "30mbg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.46,149.71l-7.4-5.61,6.31-6.81a1.28,1.28,0,0,0-.35-2L172.76,131l5-7.8a1.29,1.29,0,0,0-.7-1.93l-8.87-2.74,3.6-8.56a1.28,1.28,0,0,0-1-1.77l-9.21-1.15L163.65,98a1.28,1.28,0,0,0-1.32-1.56l-9.27.45.46-9.27A1.28,1.28,0,0,0,152,86.34l-9,2.06-1.16-9.21a1.28,1.28,0,0,0-1.77-1l-8.56,3.61-2.74-8.87a1.28,1.28,0,0,0-1.92-.7l-7.8,5L114.71,69a1.28,1.28,0,0,0-2-.36l-6.81,6.32-5.61-7.4a1.29,1.29,0,0,0-2,0l-5.61,7.4-6.81-6.32a1.28,1.28,0,0,0-2,.36l-4.24,8.26-7.8-5a1.28,1.28,0,0,0-1.92.7l-2.75,8.87-8.55-3.61a1.28,1.28,0,0,0-1.77,1L55.61,88.4l-9.06-2.06A1.28,1.28,0,0,0,45,87.65l.46,9.27-9.28-.45A1.27,1.27,0,0,0,34.86,98l2.06,9.06-9.21,1.15a1.28,1.28,0,0,0-1,1.77l3.6,8.56-8.87,2.74a1.28,1.28,0,0,0-.7,1.92l5,7.81-8.26,4.24a1.28,1.28,0,0,0-.35,2l6.31,6.81-7.4,5.61a1.28,1.28,0,0,0,0,2l7.4,5.61-6.31,6.81a1.29,1.29,0,0,0,.35,2l8.26,4.24-5,7.8a1.28,1.28,0,0,0,.7,1.92l8.87,2.74-3.6,8.56a1.28,1.28,0,0,0,1,1.77l9.21,1.16-2.06,9.05A1.28,1.28,0,0,0,36.17,205l9.28-.46L45,213.81a1.29,1.29,0,0,0,1.56,1.32l9.06-2.06,1.16,9.21a1.28,1.28,0,0,0,1.77,1l8.55-3.6,2.75,8.87a1.28,1.28,0,0,0,1.92.7l7.8-5,4.24,8.26a1.28,1.28,0,0,0,2,.36l6.81-6.31,5.61,7.4a1.3,1.3,0,0,0,2,0l5.61-7.4,6.81,6.31a1.28,1.28,0,0,0,2-.36l4.24-8.26,7.8,5a1.28,1.28,0,0,0,1.92-.7l2.74-8.87,8.56,3.6a1.28,1.28,0,0,0,1.77-1l1.16-9.21,9,2.06a1.29,1.29,0,0,0,1.57-1.32l-.46-9.27,9.27.46a1.29,1.29,0,0,0,1.32-1.57l-2.06-9.05,9.21-1.16a1.28,1.28,0,0,0,1-1.77l-3.6-8.56,8.87-2.74a1.28,1.28,0,0,0,.7-1.92l-5-7.8,8.26-4.24a1.29,1.29,0,0,0,.35-2l-6.31-6.81,7.4-5.61A1.29,1.29,0,0,0,182.46,149.71Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.05,169.33l8.09-4.16L175,158.49a1.51,1.51,0,0,1,.2-2.26l7.26-5.5-7.26-5.5A1.51,1.51,0,0,1,175,143l6.19-6.68-8.09-4.16a1.5,1.5,0,0,1-.59-2.19l4.93-7.65-8.7-2.69a1.5,1.5,0,0,1-1-2.06l3.54-8.38-9-1.14a1.51,1.51,0,0,1-1.31-1.86l2-8.88-9.09.45a1.51,1.51,0,0,1-1.61-1.6l.45-9.1-8.87,2a1.5,1.5,0,0,1-1.86-1.3l-1.14-9-8.39,3.53a1.51,1.51,0,0,1-2.06-1l-2.69-8.7L120,77.53a1.5,1.5,0,0,1-2.19-.59l-4.16-8.1L107,75a1.52,1.52,0,0,1-2.27-.2l-5.5-7.25-5.5,7.25a1.51,1.51,0,0,1-2.26.2l-6.67-6.19-4.16,8.1a1.52,1.52,0,0,1-2.2.59l-7.65-4.94-2.68,8.7a1.51,1.51,0,0,1-2.06,1l-8.39-3.53-1.14,9a1.5,1.5,0,0,1-1.86,1.3L45.8,87l.45,9.1a1.5,1.5,0,0,1-1.6,1.6l-9.1-.45,2,8.88A1.51,1.51,0,0,1,36.27,108l-9,1.14,3.53,8.38a1.5,1.5,0,0,1-1,2.06l-8.69,2.69,4.93,7.65a1.5,1.5,0,0,1-.59,2.19l-8.09,4.16L23.55,143a1.5,1.5,0,0,1-.2,2.26l-7.25,5.5,7.25,5.5a1.5,1.5,0,0,1,.2,2.26l-6.18,6.68,8.09,4.16a1.5,1.5,0,0,1,.59,2.19l-4.93,7.65,8.69,2.69a1.5,1.5,0,0,1,1,2.06l-3.53,8.39,9,1.13a1.51,1.51,0,0,1,1.31,1.86l-2,8.88,9.1-.45a1.5,1.5,0,0,1,1.6,1.61l-.45,9.09,8.88-2a1.5,1.5,0,0,1,1.86,1.3l1.14,9,8.39-3.53a1.51,1.51,0,0,1,2.06,1l2.68,8.7,7.65-4.93a1.51,1.51,0,0,1,2.2.58l4.16,8.1,6.67-6.19a1.51,1.51,0,0,1,2.26.2l5.5,7.25,5.5-7.25a1.52,1.52,0,0,1,2.27-.2l6.67,6.19,4.16-8.1a1.5,1.5,0,0,1,2.19-.58l7.65,4.93,2.69-8.7a1.51,1.51,0,0,1,2.06-1l8.39,3.53,1.14-9a1.5,1.5,0,0,1,1.86-1.3l8.87,2-.45-9.09a1.52,1.52,0,0,1,1.61-1.61l9.09.45-2-8.88a1.51,1.51,0,0,1,1.31-1.86l9-1.13-3.54-8.39a1.5,1.5,0,0,1,1-2.06l8.7-2.69-4.93-7.65A1.5,1.5,0,0,1,173.05,169.33Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.19,150.73A35.94,35.94,0,1,1,99.25,114.8,36,36,0,0,1,135.19,150.73ZM99.25,91.55a59.19,59.19,0,1,0,59.19,59.18A59.18,59.18,0,0,0,99.25,91.55Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.3,150.84a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,135.3,150.84ZM99.36,91.66a59.19,59.19,0,1,0,59.19,59.18A59.17,59.17,0,0,0,99.36,91.66Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.41,151A35.94,35.94,0,1,1,99.47,115,36,36,0,0,1,135.41,151ZM99.47,91.76A59.19,59.19,0,1,0,158.66,151,59.18,59.18,0,0,0,99.47,91.76Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.51,151.06a35.93,35.93,0,1,1-35.93-35.93A36,36,0,0,1,135.51,151.06ZM99.58,91.87a59.19,59.19,0,1,0,59.19,59.19A59.18,59.18,0,0,0,99.58,91.87Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135.62,151.17a35.93,35.93,0,1,1-35.93-35.94A36,36,0,0,1,135.62,151.17ZM99.69,92a59.19,59.19,0,1,0,59.19,59.19A59.19,59.19,0,0,0,99.69,92Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M135.73,151.28A35.94,35.94,0,1,1,99.8,115.34,36,36,0,0,1,135.73,151.28ZM99.8,92.09A59.19,59.19,0,1,0,159,151.28,59.19,59.19,0,0,0,99.8,92.09Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.84,151.39a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,135.84,151.39ZM99.91,92.2a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,99.91,92.2Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M136,151.5A35.94,35.94,0,1,1,100,115.56,36,36,0,0,1,136,151.5ZM100,92.31A59.19,59.19,0,1,0,159.2,151.5,59.19,59.19,0,0,0,100,92.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M136.06,151.61a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,136.06,151.61ZM100.13,92.42a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,100.13,92.42Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.17,151.71a35.94,35.94,0,1,1-35.93-35.93A36,36,0,0,1,136.17,151.71ZM100.24,92.53a59.19,59.19,0,1,0,59.18,59.18A59.19,59.19,0,0,0,100.24,92.53Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M136.28,151.82a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,136.28,151.82ZM100.34,92.64a59.19,59.19,0,1,0,59.19,59.18A59.19,59.19,0,0,0,100.34,92.64Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M136.39,151.93A35.94,35.94,0,1,1,100.45,116,36,36,0,0,1,136.39,151.93ZM100.45,92.75a59.19,59.19,0,1,0,59.19,59.18A59.18,59.18,0,0,0,100.45,92.75Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M136.28,151.82a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,136.28,151.82ZM100.34,92.64a59.19,59.19,0,1,0,59.19,59.18A59.19,59.19,0,0,0,100.34,92.64Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.17,151.71a35.94,35.94,0,1,1-35.93-35.93A36,36,0,0,1,136.17,151.71ZM100.24,92.53a59.19,59.19,0,1,0,59.18,59.18A59.19,59.19,0,0,0,100.24,92.53Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M136.06,151.61a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,136.06,151.61ZM100.13,92.42a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,100.13,92.42Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M136,151.5A35.94,35.94,0,1,1,100,115.56,36,36,0,0,1,136,151.5ZM100,92.31A59.19,59.19,0,1,0,159.2,151.5,59.19,59.19,0,0,0,100,92.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.84,151.39a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,135.84,151.39ZM99.91,92.2a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,99.91,92.2Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M135.73,151.28A35.94,35.94,0,1,1,99.8,115.34,36,36,0,0,1,135.73,151.28ZM99.8,92.09A59.19,59.19,0,1,0,159,151.28,59.19,59.19,0,0,0,99.8,92.09Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135.62,151.17a35.93,35.93,0,1,1-35.93-35.94A36,36,0,0,1,135.62,151.17ZM99.69,92a59.19,59.19,0,1,0,59.19,59.19A59.19,59.19,0,0,0,99.69,92Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.51,151.06a35.93,35.93,0,1,1-35.93-35.93A36,36,0,0,1,135.51,151.06ZM99.58,91.87a59.19,59.19,0,1,0,59.19,59.19A59.18,59.18,0,0,0,99.58,91.87Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.41,151A35.94,35.94,0,1,1,99.47,115,36,36,0,0,1,135.41,151ZM99.47,91.76A59.19,59.19,0,1,0,158.66,151,59.18,59.18,0,0,0,99.47,91.76Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.3,150.84a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,135.3,150.84ZM99.36,91.66a59.19,59.19,0,1,0,59.19,59.18A59.17,59.17,0,0,0,99.36,91.66Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.19,150.73A35.94,35.94,0,1,1,99.25,114.8,36,36,0,0,1,135.19,150.73ZM99.25,91.55a59.19,59.19,0,1,0,59.19,59.18A59.18,59.18,0,0,0,99.25,91.55Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.19,150.73A35.94,35.94,0,1,1,99.25,114.8,36,36,0,0,1,135.19,150.73ZM99.25,91.55a59.19,59.19,0,1,0,59.19,59.18A59.18,59.18,0,0,0,99.25,91.55Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.3,150.84a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,135.3,150.84ZM99.36,91.66a59.19,59.19,0,1,0,59.19,59.18A59.17,59.17,0,0,0,99.36,91.66Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.41,151A35.94,35.94,0,1,1,99.47,115,36,36,0,0,1,135.41,151ZM99.47,91.76A59.19,59.19,0,1,0,158.66,151,59.18,59.18,0,0,0,99.47,91.76Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.51,151.06a35.93,35.93,0,1,1-35.93-35.93A36,36,0,0,1,135.51,151.06ZM99.58,91.87a59.19,59.19,0,1,0,59.19,59.19A59.18,59.18,0,0,0,99.58,91.87Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135.62,151.17a35.93,35.93,0,1,1-35.93-35.94A36,36,0,0,1,135.62,151.17ZM99.69,92a59.19,59.19,0,1,0,59.19,59.19A59.19,59.19,0,0,0,99.69,92Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M135.73,151.28A35.94,35.94,0,1,1,99.8,115.34,36,36,0,0,1,135.73,151.28ZM99.8,92.09A59.19,59.19,0,1,0,159,151.28,59.19,59.19,0,0,0,99.8,92.09Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.84,151.39a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,135.84,151.39ZM99.91,92.2a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,99.91,92.2Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M136,151.5A35.94,35.94,0,1,1,100,115.56,36,36,0,0,1,136,151.5ZM100,92.31A59.19,59.19,0,1,0,159.2,151.5,59.19,59.19,0,0,0,100,92.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M136.06,151.61a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,136.06,151.61ZM100.13,92.42a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,100.13,92.42Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.17,151.71a35.94,35.94,0,1,1-35.93-35.93A36,36,0,0,1,136.17,151.71ZM100.24,92.53a59.19,59.19,0,1,0,59.18,59.18A59.19,59.19,0,0,0,100.24,92.53Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M136.28,151.82a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,136.28,151.82ZM100.34,92.64a59.19,59.19,0,1,0,59.19,59.18A59.19,59.19,0,0,0,100.34,92.64Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M136.39,151.93A35.94,35.94,0,1,1,100.45,116,36,36,0,0,1,136.39,151.93ZM100.45,92.75a59.19,59.19,0,1,0,59.19,59.18A59.18,59.18,0,0,0,100.45,92.75Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M136.28,151.82a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,136.28,151.82ZM100.34,92.64a59.19,59.19,0,1,0,59.19,59.18A59.19,59.19,0,0,0,100.34,92.64Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136.17,151.71a35.94,35.94,0,1,1-35.93-35.93A36,36,0,0,1,136.17,151.71ZM100.24,92.53a59.19,59.19,0,1,0,59.18,59.18A59.19,59.19,0,0,0,100.24,92.53Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M136.06,151.61a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,136.06,151.61ZM100.13,92.42a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,100.13,92.42Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M136,151.5A35.94,35.94,0,1,1,100,115.56,36,36,0,0,1,136,151.5ZM100,92.31A59.19,59.19,0,1,0,159.2,151.5,59.19,59.19,0,0,0,100,92.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.84,151.39a35.94,35.94,0,1,1-35.93-35.94A36,36,0,0,1,135.84,151.39ZM99.91,92.2a59.19,59.19,0,1,0,59.18,59.19A59.19,59.19,0,0,0,99.91,92.2Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M135.73,151.28A35.94,35.94,0,1,1,99.8,115.34,36,36,0,0,1,135.73,151.28ZM99.8,92.09A59.19,59.19,0,1,0,159,151.28,59.19,59.19,0,0,0,99.8,92.09Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135.62,151.17a35.93,35.93,0,1,1-35.93-35.94A36,36,0,0,1,135.62,151.17ZM99.69,92a59.19,59.19,0,1,0,59.19,59.19A59.19,59.19,0,0,0,99.69,92Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.51,151.06a35.93,35.93,0,1,1-35.93-35.93A36,36,0,0,1,135.51,151.06ZM99.58,91.87a59.19,59.19,0,1,0,59.19,59.19A59.18,59.18,0,0,0,99.58,91.87Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.41,151A35.94,35.94,0,1,1,99.47,115,36,36,0,0,1,135.41,151ZM99.47,91.76A59.19,59.19,0,1,0,158.66,151,59.18,59.18,0,0,0,99.47,91.76Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.3,150.84a35.94,35.94,0,1,1-35.94-35.93A36,36,0,0,1,135.3,150.84ZM99.36,91.66a59.19,59.19,0,1,0,59.19,59.18A59.17,59.17,0,0,0,99.36,91.66Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.19,150.73A35.94,35.94,0,1,1,99.25,114.8,36,36,0,0,1,135.19,150.73ZM99.25,91.55a59.19,59.19,0,1,0,59.19,59.18A59.18,59.18,0,0,0,99.25,91.55Z",
    transform: "translate(-15.54 -67.02)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M51.78,149.63a4,4,0,1,0,4,4A4,4,0,0,0,51.78,149.63Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M146.72,149.63a4,4,0,1,0,4,4A4,4,0,0,0,146.72,149.63Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M165.31,148.08a.88.88,0,0,0-1.2,0,.8.8,0,0,0,0,1.15s3.32,3.26,4.2,4.21a.83.83,0,0,0,1.2,0,.9.9,0,0,0,0-1.24S166.24,148.93,165.31,148.08Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M165.36,151.38a.88.88,0,0,0-1.2,0,.8.8,0,0,0,0,1.15s3.16,3.42,4,4.41a.83.83,0,0,0,1.19.11.9.9,0,0,0,.1-1.24S166.24,152.27,165.36,151.38Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M165.25,154.68a.86.86,0,0,0-1.19-.07.77.77,0,0,0-.09,1.14s3,3.57,3.76,4.61a.83.83,0,0,0,1.18.17.91.91,0,0,0,.16-1.24S166.09,155.61,165.25,154.68Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M165,158a.87.87,0,0,0-1.19-.12.78.78,0,0,0-.15,1.13s2.8,3.72,3.53,4.79a.82.82,0,0,0,1.17.23.9.9,0,0,0,.22-1.23S165.76,158.94,165,158Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M164.54,161.23a.87.87,0,0,0-1.18-.19.79.79,0,0,0-.2,1.13s2.6,3.85,3.28,5a.83.83,0,0,0,1.16.29.9.9,0,0,0,.28-1.21S165.28,162.24,164.54,161.23Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M163.94,164.47a.87.87,0,0,0-1.17-.24.78.78,0,0,0-.26,1.11s2.41,4,3,5.12a.82.82,0,0,0,1.15.34.9.9,0,0,0,.34-1.19S164.62,165.52,163.94,164.47Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M163.17,167.68a.86.86,0,0,0-1.15-.3.78.78,0,0,0-.31,1.1s2.2,4.09,2.76,5.26a.83.83,0,0,0,1.13.4A.91.91,0,0,0,166,173S163.81,168.76,163.17,167.68Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M162.25,170.85a.86.86,0,0,0-1.14-.37.79.79,0,0,0-.36,1.09s2,4.19,2.5,5.4a.83.83,0,0,0,1.1.45.9.9,0,0,0,.46-1.16S162.83,172,162.25,170.85Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M161.17,174a.86.86,0,0,0-1.12-.42.79.79,0,0,0-.42,1.06s1.79,4.3,2.23,5.52a.83.83,0,0,0,1.08.51.9.9,0,0,0,.51-1.13S161.69,175.1,161.17,174Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M159.93,177a.85.85,0,0,0-1.09-.48.78.78,0,0,0-.47,1s1.57,4.38,1.95,5.63a.82.82,0,0,0,1.05.56.9.9,0,0,0,.57-1.11S160.4,178.18,159.93,177Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M158.55,180a.88.88,0,0,0-1.08-.54.79.79,0,0,0-.52,1s1.35,4.45,1.67,5.72a.83.83,0,0,0,1,.61.9.9,0,0,0,.62-1.07S159,181.19,158.55,180Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M157,182.92a.87.87,0,0,0-1-.58.79.79,0,0,0-.58,1s1.13,4.51,1.39,5.79a.83.83,0,0,0,1,.67.91.91,0,0,0,.67-1S157.36,184.13,157,182.92Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M155.33,185.76a.87.87,0,0,0-1-.64.79.79,0,0,0-.62,1c.16.68.9,4.56,1.09,5.85a.84.84,0,0,0,1,.72.9.9,0,0,0,.72-1S155.61,187,155.33,185.76Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M153.51,188.51a.87.87,0,0,0-1-.69.79.79,0,0,0-.66.94c.12.69.67,4.6.8,5.9a.83.83,0,0,0,.92.76.9.9,0,0,0,.77-1S153.73,189.74,153.51,188.51Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M151.56,191.16a.88.88,0,0,0-.95-.73.8.8,0,0,0-.71.9c.1.7.45,4.63.51,5.94a.83.83,0,0,0,.89.8.89.89,0,0,0,.81-.93S151.72,192.4,151.56,191.16Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M149.47,193.72a.87.87,0,0,0-.9-.78.79.79,0,0,0-.75.87c.06.7.22,4.65.21,5.95a.82.82,0,0,0,.84.84.88.88,0,0,0,.86-.89S149.57,195,149.47,193.72Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M146.4,195.35a.77.77,0,0,0-.79.82c0,.72,0,4.67-.09,6a.83.83,0,0,0,.8.89.88.88,0,0,0,.91-.84s.08-4.75,0-6A.86.86,0,0,0,146.4,195.35Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M144.12,197.64a.78.78,0,0,0-.83.79c0,.72-.24,4.66-.39,5.94a.83.83,0,0,0,.76.92.87.87,0,0,0,1-.79s.32-4.73.33-6A.86.86,0,0,0,144.12,197.64Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M141.72,199.82a.78.78,0,0,0-.86.75c0,.72-.46,4.65-.69,5.91a.84.84,0,0,0,.71,1,.87.87,0,0,0,1-.75s.56-4.7.63-6A.86.86,0,0,0,141.72,199.82Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M139.22,201.88a.78.78,0,0,0-.9.71c-.07.7-.69,4.62-1,5.86a.81.81,0,0,0,.65,1,.86.86,0,0,0,1-.69s.8-4.66.93-5.93A.87.87,0,0,0,139.22,201.88Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M136.62,203.81a.79.79,0,0,0-.93.66s-.92,4.59-1.27,5.81a.83.83,0,0,0,.61,1,.88.88,0,0,0,1.07-.63s1-4.62,1.21-5.88A.87.87,0,0,0,136.62,203.81Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M133.93,205.61a.78.78,0,0,0-1,.62s-1.15,4.52-1.56,5.73a.82.82,0,0,0,.56,1,.87.87,0,0,0,1.09-.58s1.26-4.56,1.51-5.81A.86.86,0,0,0,133.93,205.61Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M131.16,207.27a.8.8,0,0,0-1,.57s-1.37,4.46-1.84,5.64a.83.83,0,0,0,.5,1.09.9.9,0,0,0,1.13-.52s1.48-4.49,1.8-5.73A.89.89,0,0,0,131.16,207.27Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M128.3,208.8a.78.78,0,0,0-1,.51s-1.6,4.39-2.12,5.55a.82.82,0,0,0,.44,1.1.9.9,0,0,0,1.16-.46s1.7-4.41,2.08-5.63A.87.87,0,0,0,128.3,208.8Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M125.37,210.17a.81.81,0,0,0-1.05.47s-1.81,4.29-2.39,5.43a.83.83,0,0,0,.39,1.13.9.9,0,0,0,1.17-.4s1.93-4.32,2.36-5.53A.87.87,0,0,0,125.37,210.17Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M122.38,211.4a.81.81,0,0,0-1.07.41s-2,4.2-2.67,5.3a.83.83,0,0,0,.34,1.15.89.89,0,0,0,1.19-.34s2.14-4.21,2.63-5.4A.86.86,0,0,0,122.38,211.4Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M119.33,212.48a.81.81,0,0,0-1.09.35s-2.24,4.1-2.93,5.17a.83.83,0,0,0,.27,1.16.9.9,0,0,0,1.21-.28s2.36-4.1,2.91-5.26A.87.87,0,0,0,119.33,212.48Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M116.22,213.4a.81.81,0,0,0-1.1.3s-2.44,4-3.19,5a.82.82,0,0,0,.22,1.17.9.9,0,0,0,1.22-.21s2.56-4,3.17-5.11A.88.88,0,0,0,116.22,213.4Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M113.08,214.17a.81.81,0,0,0-1.12.24s-2.63,3.85-3.43,4.84a.83.83,0,0,0,.16,1.19.9.9,0,0,0,1.23-.16s2.75-3.84,3.42-4.94A.87.87,0,0,0,113.08,214.17Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M109.9,214.77a.81.81,0,0,0-1.13.19s-2.82,3.71-3.67,4.67a.83.83,0,0,0,.1,1.19.9.9,0,0,0,1.24-.1s2.94-3.7,3.66-4.76A.88.88,0,0,0,109.9,214.77Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M106.7,215.22a.81.81,0,0,0-1.14.13s-3,3.57-3.9,4.48a.83.83,0,0,0,0,1.19.9.9,0,0,0,1.24,0s3.12-3.55,3.89-4.58A.87.87,0,0,0,106.7,215.22Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M103.47,215.51a.8.8,0,0,0-1.14.07s-3.18,3.42-4.12,4.28a.83.83,0,0,0,0,1.2.89.89,0,0,0,1.24,0s3.29-3.39,4.11-4.38A.86.86,0,0,0,103.47,215.51Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M100.25,216.83a.86.86,0,0,0,0-1.2.8.8,0,0,0-1.14,0s-3.34,3.27-4.32,4.08a.82.82,0,0,0-.08,1.19.88.88,0,0,0,1.24.08S99.38,217.78,100.25,216.83Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M97,215.6a.79.79,0,0,0-1.15,0s-3.5,3.09-4.51,3.86a.81.81,0,0,0-.14,1.18.88.88,0,0,0,1.23.14S96,217.7,97,216.8A.87.87,0,0,0,97,215.6Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M93.76,215.41a.79.79,0,0,0-1.14-.09S89,218.24,87.92,219a.83.83,0,0,0-.19,1.18.88.88,0,0,0,1.22.2s3.76-2.88,4.71-3.73A.86.86,0,0,0,93.76,215.41Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M90.54,215.06a.77.77,0,0,0-1.13-.14s-3.79,2.73-4.88,3.38a.84.84,0,0,0-.25,1.17.87.87,0,0,0,1.21.26s3.9-2.68,4.9-3.48A.87.87,0,0,0,90.54,215.06Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M87.35,214.55a.79.79,0,0,0-1.13-.2s-3.92,2.54-5,3.14a.83.83,0,0,0-.31,1.15.87.87,0,0,0,1.2.32s4-2.48,5.06-3.23A.87.87,0,0,0,87.35,214.55Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M84.18,213.88a.79.79,0,0,0-1.11-.26s-4,2.34-5.19,2.89a.82.82,0,0,0-.37,1.13.87.87,0,0,0,1.18.38s4.14-2.28,5.21-3A.87.87,0,0,0,84.18,213.88Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M81.05,213.05a.79.79,0,0,0-1.1-.31s-4.15,2.13-5.33,2.62a.82.82,0,0,0-.42,1.11.88.88,0,0,0,1.16.45s4.25-2.07,5.36-2.72A.87.87,0,0,0,81.05,213.05Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M78,212.07a.79.79,0,0,0-1.08-.37s-4.26,1.92-5.46,2.35a.82.82,0,0,0-.48,1.09.88.88,0,0,0,1.14.5s4.35-1.85,5.49-2.44A.87.87,0,0,0,78,212.07Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M74.49,212a.86.86,0,0,0,.45-1.11.79.79,0,0,0-1.06-.42s-4.35,1.7-5.57,2.07a.83.83,0,0,0-.53,1.07.89.89,0,0,0,1.11.56S73.33,212.58,74.49,212Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M71.47,210.73a.86.86,0,0,0,.5-1.08.79.79,0,0,0-1-.48s-4.42,1.48-5.66,1.79a.83.83,0,0,0-.59,1,.9.9,0,0,0,1.08.62S70.28,211.21,71.47,210.73Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M68.51,209.27a.86.86,0,0,0,.56-1.06.8.8,0,0,0-1-.53s-4.49,1.25-5.75,1.51a.82.82,0,0,0-.64,1,.92.92,0,0,0,1,.67S67.3,209.69,68.51,209.27Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M65.63,207.67a.87.87,0,0,0,.61-1,.8.8,0,0,0-1-.59s-4.55,1-5.81,1.22a.82.82,0,0,0-.69,1,.91.91,0,0,0,1,.72S64.4,208,65.63,207.67Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M62.84,205.92a.87.87,0,0,0,.66-1,.82.82,0,0,0-1-.64s-4.59.8-5.87.93a.83.83,0,0,0-.74.94.9.9,0,0,0,1,.77C57.63,206.84,61.59,206.21,62.84,205.92Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M60.13,204a.86.86,0,0,0,.71-1,.81.81,0,0,0-.91-.69s-4.62.56-5.91.64a.82.82,0,0,0-.78.9.89.89,0,0,0,.93.82C54.89,204.7,58.87,204.26,60.13,204Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M57.53,202a.87.87,0,0,0,.75-.93.82.82,0,0,0-.88-.74s-4.64.33-5.93.35a.83.83,0,0,0-.83.86.9.9,0,0,0,.9.86C52.26,202.42,56.26,202.17,57.53,202Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M55,199.87a.86.86,0,0,0,.8-.89.81.81,0,0,0-.84-.78s-4.64.1-5.94.06a.82.82,0,0,0-.87.82.91.91,0,0,0,.86.9C49.74,200,53.76,200,55,199.87Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M52.62,197.61a.88.88,0,0,0,.85-.85.79.79,0,0,0-.8-.82s-4.64-.14-5.94-.24a.83.83,0,0,0-.91.77.9.9,0,0,0,.82.94C47.35,197.48,51.36,197.62,52.62,197.61Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M50.34,195.23a.88.88,0,0,0,.89-.81.79.79,0,0,0-.75-.86s-4.63-.37-5.93-.54a.83.83,0,0,0-.94.74.89.89,0,0,0,.76,1C45.09,194.83,49.09,195.17,50.34,195.23Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M48.18,192.73a.86.86,0,0,0,.93-.76.79.79,0,0,0-.71-.9s-4.61-.6-5.89-.82a.82.82,0,0,0-1,.68.89.89,0,0,0,.72,1C43,192.07,46.94,192.61,48.18,192.73Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M46.15,190.13a.85.85,0,0,0,1-.71.78.78,0,0,0-.66-.93s-4.57-.83-5.84-1.12a.84.84,0,0,0-1,.64.9.9,0,0,0,.67,1C41,189.21,44.92,190,46.15,190.13Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M44.25,187.44a.88.88,0,0,0,1-.67.79.79,0,0,0-.62-1s-4.53-1.05-5.78-1.41a.82.82,0,0,0-1,.59.89.89,0,0,0,.61,1.07S43,187.2,44.25,187.44Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M42.49,184.65a.87.87,0,0,0,1-.61.78.78,0,0,0-.57-1s-4.47-1.28-5.71-1.7a.83.83,0,0,0-1.07.53.9.9,0,0,0,.57,1.11S41.28,184.35,42.49,184.65Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M40.87,181.78a.87.87,0,0,0,1.06-.56.8.8,0,0,0-.52-1s-4.41-1.49-5.62-2a.83.83,0,0,0-1.1.47.9.9,0,0,0,.51,1.13S39.67,181.42,40.87,181.78Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M39.4,178.83a.86.86,0,0,0,1.08-.51.79.79,0,0,0-.47-1s-4.33-1.71-5.51-2.25a.82.82,0,0,0-1.12.42.89.89,0,0,0,.45,1.15S38.21,178.41,39.4,178.83Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M38.07,175.82a.88.88,0,0,0,1.11-.46.79.79,0,0,0-.42-1.06s-4.24-1.93-5.39-2.53a.83.83,0,0,0-1.14.36.9.9,0,0,0,.39,1.18S36.91,175.34,38.07,175.82Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M36.89,172.74a.87.87,0,0,0,1.13-.4.79.79,0,0,0-.36-1.09s-4.13-2.13-5.26-2.79a.83.83,0,0,0-1.16.31.9.9,0,0,0,.34,1.19S35.76,172.2,36.89,172.74Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M35.88,169.6a.85.85,0,0,0,1.14-.34.78.78,0,0,0-.31-1.1s-4-2.34-5.11-3.06a.84.84,0,0,0-1.17.25.91.91,0,0,0,.28,1.21S34.77,169,35.88,169.6Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M35,166.42a.88.88,0,0,0,1.16-.28.79.79,0,0,0-.26-1.12s-3.89-2.54-5-3.31a.83.83,0,0,0-1.18.19.9.9,0,0,0,.22,1.22S34,165.77,35,166.42Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M34.32,163.2A.87.87,0,0,0,35.5,163a.79.79,0,0,0-.21-1.12s-3.76-2.74-4.77-3.55a.83.83,0,0,0-1.19.13.9.9,0,0,0,.15,1.23S33.28,162.5,34.32,163.2Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M33.78,159.94a.87.87,0,0,0,1.19-.16.79.79,0,0,0-.15-1.14s-3.62-2.91-4.59-3.78a.82.82,0,0,0-1.19.07.89.89,0,0,0,.09,1.24S32.78,159.19,33.78,159.94Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M33.41,156.67a.86.86,0,0,0,1.19-.11.77.77,0,0,0-.09-1.14s-3.47-3.09-4.4-4a.81.81,0,0,0-1.19,0,.9.9,0,0,0,0,1.24S32.44,155.87,33.41,156.67Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M33.2,153.38a.86.86,0,0,0,1.19,0,.77.77,0,0,0,0-1.14s-3.31-3.26-4.19-4.22a.83.83,0,0,0-1.2-.05.9.9,0,0,0,0,1.24S32.27,152.53,33.2,153.38Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M33.15,150.08a.85.85,0,0,0,1.19,0,.78.78,0,0,0,0-1.14s-3.15-3.42-4-4.42a.83.83,0,0,0-1.19-.11.9.9,0,0,0-.1,1.24S32.26,149.19,33.15,150.08Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M33.26,146.78a.85.85,0,0,0,1.19.07.78.78,0,0,0,.09-1.14s-3-3.57-3.76-4.61a.83.83,0,0,0-1.19-.16.89.89,0,0,0-.15,1.23S32.42,145.85,33.26,146.78Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M33.53,143.5a.87.87,0,0,0,1.19.13.8.8,0,0,0,.15-1.14s-2.8-3.71-3.53-4.79a.83.83,0,0,0-1.18-.22A.9.9,0,0,0,30,138.7S32.74,142.53,33.53,143.5Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M34,140.23a.86.86,0,0,0,1.18.19.79.79,0,0,0,.2-1.13s-2.6-3.85-3.28-5a.82.82,0,0,0-1.16-.28.89.89,0,0,0-.28,1.21S33.23,139.22,34,140.23Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M34.57,137a.87.87,0,0,0,1.17.25.8.8,0,0,0,.26-1.12s-2.41-4-3-5.12a.83.83,0,0,0-1.15-.34.9.9,0,0,0-.34,1.19S33.88,135.94,34.57,137Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M35.33,133.78a.87.87,0,0,0,1.16.31.79.79,0,0,0,.31-1.1s-2.21-4.09-2.77-5.27a.82.82,0,0,0-1.12-.4.89.89,0,0,0-.4,1.18S34.7,132.7,35.33,133.78Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M36.26,130.62a.86.86,0,0,0,1.13.36.78.78,0,0,0,.37-1.08s-2-4.2-2.5-5.4a.83.83,0,0,0-1.11-.46.91.91,0,0,0-.45,1.16S35.68,129.51,36.26,130.62Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M37.34,127.5a.86.86,0,0,0,1.12.42.78.78,0,0,0,.42-1.06s-1.79-4.29-2.23-5.52a.83.83,0,0,0-1.08-.51.91.91,0,0,0-.52,1.13S36.81,126.37,37.34,127.5Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M38.57,124.45a.87.87,0,0,0,1.1.47.78.78,0,0,0,.47-1s-1.42-3.89-2-5.62a.82.82,0,0,0-1-.56.89.89,0,0,0-.57,1.1S38.11,123.28,38.57,124.45Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M40,121.46A.87.87,0,0,0,41,122a.8.8,0,0,0,.53-1s-1.36-4.45-1.67-5.72a.83.83,0,0,0-1-.61.91.91,0,0,0-.62,1.08S39.55,120.27,40,121.46Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M41.5,118.54a.86.86,0,0,0,1,.58.78.78,0,0,0,.57-1s-1.13-4.51-1.38-5.79a.82.82,0,0,0-1-.66.89.89,0,0,0-.67,1S41.15,117.34,41.5,118.54Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M43.18,115.7a.86.86,0,0,0,1,.64.79.79,0,0,0,.62-1c-.16-.68-.9-4.57-1.09-5.86a.83.83,0,0,0-1-.71.89.89,0,0,0-.72,1S42.89,114.49,43.18,115.7Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M45,113a.86.86,0,0,0,1,.68.78.78,0,0,0,.66-.93c-.12-.69-.67-4.61-.8-5.91a.84.84,0,0,0-.92-.76.9.9,0,0,0-.77,1S44.77,111.72,45,113Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M47,110.3a.86.86,0,0,0,.95.73.78.78,0,0,0,.7-.9c-.09-.7-.44-4.63-.5-5.93a.84.84,0,0,0-.89-.81.89.89,0,0,0-.81.94S46.79,109.06,47,110.3Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M49,107.74a.86.86,0,0,0,.91.78.78.78,0,0,0,.75-.86c-.07-.71-.22-4.66-.21-6a.83.83,0,0,0-.84-.85.89.89,0,0,0-.87.89S48.93,106.5,49,107.74Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M52.11,106.12a.78.78,0,0,0,.79-.83c0-.71,0-4.67.09-6a.83.83,0,0,0-.8-.89.87.87,0,0,0-.91.84s-.08,4.75,0,6A.87.87,0,0,0,52.11,106.12Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M54.39,103.82a.78.78,0,0,0,.83-.79c0-.71.23-4.66.39-5.93a.83.83,0,0,0-.76-.93.88.88,0,0,0-1,.8s-.32,4.73-.33,6A.85.85,0,0,0,54.39,103.82Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M56.79,101.64a.78.78,0,0,0,.86-.75c0-.71.46-4.65.68-5.9a.83.83,0,0,0-.7-1,.89.89,0,0,0-1,.75s-.55,4.7-.63,6A.87.87,0,0,0,56.79,101.64Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M59.29,99.59a.79.79,0,0,0,.9-.71c.07-.71.68-4.63,1-5.86a.83.83,0,0,0-.66-1,.87.87,0,0,0-1,.69s-.79,4.67-.92,5.93A.87.87,0,0,0,59.29,99.59Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M61.88,97.65a.79.79,0,0,0,.94-.66s.92-4.58,1.27-5.8a.84.84,0,0,0-.61-1,.88.88,0,0,0-1.07.63s-1,4.62-1.21,5.89A.85.85,0,0,0,61.88,97.65Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M64.58,95.85a.78.78,0,0,0,1-.61s1.15-4.53,1.56-5.73a.83.83,0,0,0-.56-1.06.89.89,0,0,0-1.1.58s-1.26,4.56-1.5,5.81A.85.85,0,0,0,64.58,95.85Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M67.35,94.19a.78.78,0,0,0,1-.57s1.38-4.46,1.85-5.64a.83.83,0,0,0-.5-1.09.9.9,0,0,0-1.13.52s-1.49,4.5-1.8,5.74A.87.87,0,0,0,67.35,94.19Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M70.21,92.67a.8.8,0,0,0,1-.52s1.6-4.38,2.12-5.54a.82.82,0,0,0-.45-1.11.89.89,0,0,0-1.15.46S70,90.37,69.67,91.6A.87.87,0,0,0,70.21,92.67Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M73.14,91.29a.8.8,0,0,0,1-.46s1.82-4.3,2.4-5.43a.83.83,0,0,0-.39-1.13.9.9,0,0,0-1.18.4S73.09,89,72.65,90.19A.87.87,0,0,0,73.14,91.29Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M76.13,90.06a.8.8,0,0,0,1.07-.41s2-4.2,2.67-5.3a.83.83,0,0,0-.34-1.15.9.9,0,0,0-1.19.34s-2.15,4.21-2.64,5.4A.87.87,0,0,0,76.13,90.06Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M79.18,89a.8.8,0,0,0,1.09-.35s2.24-4.09,2.93-5.16a.84.84,0,0,0-.28-1.17.92.92,0,0,0-1.21.28s-2.35,4.1-2.9,5.26A.87.87,0,0,0,79.18,89Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M82.28,88.06a.81.81,0,0,0,1.11-.29s2.44-4,3.18-5a.82.82,0,0,0-.21-1.17.9.9,0,0,0-1.23.22s-2.55,4-3.16,5.11A.87.87,0,0,0,82.28,88.06Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M85.43,87.29a.8.8,0,0,0,1.12-.23s2.63-3.85,3.43-4.85A.83.83,0,0,0,89.82,81a.89.89,0,0,0-1.23.15S85.84,85,85.17,86.13A.86.86,0,0,0,85.43,87.29Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M88.61,86.69a.8.8,0,0,0,1.12-.18s2.83-3.72,3.68-4.67a.83.83,0,0,0-.1-1.19.9.9,0,0,0-1.24.09s-2.94,3.7-3.66,4.77A.87.87,0,0,0,88.61,86.69Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M91.81,86.24A.8.8,0,0,0,93,86.11s3-3.57,3.9-4.48a.83.83,0,0,0,0-1.19.9.9,0,0,0-1.24,0S92.45,84,91.68,85.05A.86.86,0,0,0,91.81,86.24Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M95,86a.8.8,0,0,0,1.14-.08s3.18-3.42,4.11-4.28a.83.83,0,0,0,0-1.2.89.89,0,0,0-1.24,0S95.78,83.77,95,84.76A.87.87,0,0,0,95,86Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M98.26,84.63a.87.87,0,0,0,0,1.2.8.8,0,0,0,1.15,0s3.34-3.26,4.32-4.08a.82.82,0,0,0,.07-1.19.87.87,0,0,0-1.23-.08S99.12,83.69,98.26,84.63Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M101.51,85.86a.79.79,0,0,0,1.15,0s3.5-3.09,4.51-3.85a.84.84,0,0,0,.14-1.19.89.89,0,0,0-1.24-.14s-3.6,3.06-4.52,4A.87.87,0,0,0,101.51,85.86Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M104.75,86.05a.78.78,0,0,0,1.14.09s3.65-2.92,4.7-3.63a.83.83,0,0,0,.19-1.18.87.87,0,0,0-1.22-.19s-3.76,2.87-4.72,3.72A.87.87,0,0,0,104.75,86.05Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M108,86.4a.79.79,0,0,0,1.14.15s3.79-2.73,4.87-3.39a.83.83,0,0,0,.26-1.17.89.89,0,0,0-1.22-.26s-3.89,2.69-4.89,3.49A.86.86,0,0,0,108,86.4Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M111.16,86.91a.79.79,0,0,0,1.13.2s3.92-2.53,5-3.14a.83.83,0,0,0,.31-1.15.88.88,0,0,0-1.2-.32s-4,2.49-5.06,3.24A.86.86,0,0,0,111.16,86.91Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M114.33,87.58a.78.78,0,0,0,1.11.26s4-2.34,5.19-2.88a.84.84,0,0,0,.37-1.14.88.88,0,0,0-1.18-.38s-4.14,2.28-5.22,3A.85.85,0,0,0,114.33,87.58Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M117.45,88.41a.79.79,0,0,0,1.1.31s4.16-2.13,5.33-2.61a.84.84,0,0,0,.43-1.12.88.88,0,0,0-1.16-.44s-4.25,2.07-5.36,2.71A.88.88,0,0,0,117.45,88.41Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M120.54,89.39a.78.78,0,0,0,1.08.37s4.26-1.91,5.45-2.34a.84.84,0,0,0,.48-1.1.88.88,0,0,0-1.13-.5s-4.35,1.85-5.49,2.44A.87.87,0,0,0,120.54,89.39Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M124,89.42a.86.86,0,0,0-.45,1.11.79.79,0,0,0,1.06.42s4.34-1.69,5.56-2.07a.82.82,0,0,0,.54-1.07.89.89,0,0,0-1.11-.55S125.18,88.89,124,89.42Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M127,90.73a.87.87,0,0,0-.5,1.09.8.8,0,0,0,1,.48s4.43-1.48,5.67-1.79a.83.83,0,0,0,.58-1.05.89.89,0,0,0-1.07-.61S128.23,90.26,127,90.73Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M130,92.19a.86.86,0,0,0-.55,1.06.8.8,0,0,0,1,.53s4.49-1.25,5.74-1.5a.83.83,0,0,0,.64-1,.89.89,0,0,0-1-.67S131.21,91.77,130,92.19Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M132.87,93.8a.87.87,0,0,0-.61,1,.8.8,0,0,0,1,.58s4.55-1,5.81-1.22a.82.82,0,0,0,.69-1,.9.9,0,0,0-1-.72S134.11,93.44,132.87,93.8Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M135.67,95.54a.88.88,0,0,0-.66,1,.82.82,0,0,0,1,.64s4.59-.79,5.87-.93a.83.83,0,0,0,.73-.94.9.9,0,0,0-1-.77C140.87,94.62,136.92,95.25,135.67,95.54Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M138.37,97.43a.86.86,0,0,0-.7,1,.8.8,0,0,0,.91.69s4.62-.56,5.91-.64a.83.83,0,0,0,.78-.9.89.89,0,0,0-.94-.81C143.62,96.76,139.63,97.2,138.37,97.43Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M141,99.45a.85.85,0,0,0-.75.92.8.8,0,0,0,.87.74s4.64-.33,5.94-.35a.82.82,0,0,0,.82-.86A.9.9,0,0,0,147,99C146.25,99,142.25,99.29,141,99.45Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M143.52,103.26s4.65-.09,5.95-.05a.84.84,0,0,0,.87-.83.9.9,0,0,0-.86-.89c-.72,0-4.73,0-6,.1a.87.87,0,0,0-.8.89A.8.8,0,0,0,143.52,103.26Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M151.78,105.77a.82.82,0,0,0,.9-.78.9.9,0,0,0-.81-.94c-.71-.06-4.73-.21-6-.19a.87.87,0,0,0-.84.84.8.8,0,0,0,.8.83S150.48,105.67,151.78,105.77Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M154,108.44a.83.83,0,0,0,1-.73.91.91,0,0,0-.77-1c-.71-.09-4.71-.44-6-.49a.87.87,0,0,0-.89.8.8.8,0,0,0,.75.87S152.66,108.28,154,108.44Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M150.32,108.73a.86.86,0,0,0-.92.76.78.78,0,0,0,.71.9s4.6.6,5.89.83a.84.84,0,0,0,1-.69.9.9,0,0,0-.72-1C155.54,109.39,151.57,108.85,150.32,108.73Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M152.35,111.33a.87.87,0,0,0-1,.71.8.8,0,0,0,.67.94s4.57.82,5.84,1.11a.82.82,0,0,0,1-.63.89.89,0,0,0-.67-1C157.53,112.25,153.59,111.51,152.35,111.33Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M154.25,114a.87.87,0,0,0-1,.67.77.77,0,0,0,.62,1s4.52,1,5.78,1.41a.83.83,0,0,0,1-.58.9.9,0,0,0-.62-1.08S155.48,114.26,154.25,114Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M156,116.81a.87.87,0,0,0-1,.62.78.78,0,0,0,.57,1s4.47,1.27,5.7,1.69a.84.84,0,0,0,1.08-.53.91.91,0,0,0-.57-1.11S157.23,117.11,156,116.81Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M157.64,119.68a.88.88,0,0,0-1.06.56.78.78,0,0,0,.52,1s4.41,1.5,5.62,2a.82.82,0,0,0,1.09-.48.9.9,0,0,0-.51-1.13S158.84,120,157.64,119.68Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M159.11,122.63a.87.87,0,0,0-1.08.51.78.78,0,0,0,.47,1s4.33,1.71,5.51,2.25a.82.82,0,0,0,1.12-.42.9.9,0,0,0-.46-1.15S160.29,123.05,159.11,122.63Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M160.44,125.65a.86.86,0,0,0-1.11.45.79.79,0,0,0,.42,1.07s4.24,1.92,5.39,2.52a.83.83,0,0,0,1.14-.36.89.89,0,0,0-.4-1.18S161.6,126.13,160.44,125.65Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M161.61,128.73a.87.87,0,0,0-1.13.4.79.79,0,0,0,.37,1.08s4.13,2.14,5.26,2.79a.82.82,0,0,0,1.15-.3.9.9,0,0,0-.33-1.2S162.74,129.26,161.61,128.73Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M162.63,131.86a.89.89,0,0,0-1.15.34.78.78,0,0,0,.32,1.1s4,2.35,5.11,3.06a.83.83,0,0,0,1.17-.25.91.91,0,0,0-.28-1.21S163.73,132.45,162.63,131.86Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M163.49,135.05a.86.86,0,0,0-1.16.28.78.78,0,0,0,.25,1.11s3.9,2.54,4.95,3.31a.83.83,0,0,0,1.18-.19.9.9,0,0,0-.21-1.22S164.56,135.69,163.49,135.05Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M164.19,138.27a.87.87,0,0,0-1.18.22.79.79,0,0,0,.2,1.13s3.77,2.73,4.78,3.55a.83.83,0,0,0,1.19-.13.89.89,0,0,0-.16-1.23S165.23,139,164.19,138.27Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M164.72,141.52a.86.86,0,0,0-1.18.16.79.79,0,0,0,.14,1.14s3.63,2.92,4.6,3.78a.82.82,0,0,0,1.19-.07.89.89,0,0,0-.09-1.23S165.73,142.27,164.72,141.52Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M165.1,144.79a.87.87,0,0,0-1.19.11A.78.78,0,0,0,164,146s3.48,3.1,4.4,4a.84.84,0,0,0,1.2,0,.9.9,0,0,0,0-1.24S166.06,145.59,165.1,144.79Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 36.24,
    cy: 86.61,
    r: 3.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 36.35,
    cy: 86.72,
    r: 3.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 36.46,
    cy: 86.83,
    r: 3.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 52.11,
    cy: 153.96,
    r: 3.16,
    transform: "translate(-118.35 136.14) rotate(-88.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 52.22,
    cy: 154.07,
    r: 3.16,
    transform: "translate(-118.1 137.14) rotate(-89.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 52.33,
    cy: 154.18,
    r: 3.16,
    transform: "matrix(0.01, -1, 1, 0.01, -117.96, 137.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 52.44,
    cy: 154.29,
    r: 3.16,
    transform: "matrix(0.01, -1, 1, 0.01, -117.86, 138.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 52.55,
    cy: 154.4,
    r: 3.16,
    transform: "translate(-117.79 138.74) rotate(-89.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 52.65,
    cy: 154.51,
    r: 3.16,
    transform: "translate(-117.74 139.11) rotate(-89.62)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 52.76,
    cy: 154.62,
    r: 3.16,
    transform: "translate(-117.71 139.44) rotate(-89.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 52.87,
    cy: 154.73,
    r: 3.16,
    transform: "translate(-117.67 139.75) rotate(-89.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 52.98,
    cy: 154.83,
    r: 3.16,
    transform: "translate(-117.65 140.05) rotate(-89.72)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 36.24,
    cy: 86.61,
    r: 3.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 36.35,
    cy: 86.72,
    r: 3.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 36.46,
    cy: 86.83,
    r: 3.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 52.11,
    cy: 153.96,
    r: 3.16,
    transform: "translate(-118.35 136.14) rotate(-88.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 52.22,
    cy: 154.07,
    r: 3.16,
    transform: "translate(-118.1 137.14) rotate(-89.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 52.33,
    cy: 154.18,
    r: 3.16,
    transform: "matrix(0.01, -1, 1, 0.01, -117.96, 137.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 52.44,
    cy: 154.29,
    r: 3.16,
    transform: "matrix(0.01, -1, 1, 0.01, -117.86, 138.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 52.55,
    cy: 154.4,
    r: 3.16,
    transform: "translate(-117.79 138.74) rotate(-89.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 52.65,
    cy: 154.51,
    r: 3.16,
    transform: "translate(-117.74 139.11) rotate(-89.62)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 52.76,
    cy: 154.62,
    r: 3.16,
    transform: "translate(-117.71 139.44) rotate(-89.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 52.87,
    cy: 154.73,
    r: 3.16,
    transform: "translate(-117.67 139.75) rotate(-89.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 52.98,
    cy: 154.83,
    r: 3.16,
    transform: "translate(-117.65 140.05) rotate(-89.72)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.72,150.47a3.17,3.17,0,1,0,3.17,3.17A3.17,3.17,0,0,0,146.72,150.47Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M146.83,150.58a3.17,3.17,0,1,0,3.16,3.16A3.17,3.17,0,0,0,146.83,150.58Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.94,150.69a3.17,3.17,0,1,0,3.16,3.16A3.17,3.17,0,0,0,146.94,150.69Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M147.05,150.8a3.16,3.16,0,1,0,3.16,3.16A3.16,3.16,0,0,0,147.05,150.8Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M147.16,150.91a3.16,3.16,0,1,0,3.16,3.16A3.15,3.15,0,0,0,147.16,150.91Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M147.27,151a3.16,3.16,0,1,0,3.16,3.16A3.15,3.15,0,0,0,147.27,151Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.38,151.13a3.16,3.16,0,1,0,3.16,3.16A3.15,3.15,0,0,0,147.38,151.13Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M147.49,151.24a3.16,3.16,0,1,0,3.16,3.16A3.16,3.16,0,0,0,147.49,151.24Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M147.6,151.35a3.16,3.16,0,1,0,3.16,3.16A3.16,3.16,0,0,0,147.6,151.35Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M147.71,151.45a3.17,3.17,0,1,0,3.16,3.17A3.17,3.17,0,0,0,147.71,151.45Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.81,151.56a3.17,3.17,0,1,0,3.17,3.17A3.17,3.17,0,0,0,147.81,151.56Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M147.92,151.67a3.17,3.17,0,1,0,3.17,3.16A3.17,3.17,0,0,0,147.92,151.67Z",
    transform: "translate(-15.54 -67.02)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.72,150.47a3.17,3.17,0,1,0,3.17,3.17A3.17,3.17,0,0,0,146.72,150.47Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M146.83,150.58a3.17,3.17,0,1,0,3.16,3.16A3.17,3.17,0,0,0,146.83,150.58Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.94,150.69a3.17,3.17,0,1,0,3.16,3.16A3.17,3.17,0,0,0,146.94,150.69Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M147.05,150.8a3.16,3.16,0,1,0,3.16,3.16A3.16,3.16,0,0,0,147.05,150.8Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M147.16,150.91a3.16,3.16,0,1,0,3.16,3.16A3.15,3.15,0,0,0,147.16,150.91Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M147.27,151a3.16,3.16,0,1,0,3.16,3.16A3.15,3.15,0,0,0,147.27,151Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.38,151.13a3.16,3.16,0,1,0,3.16,3.16A3.15,3.15,0,0,0,147.38,151.13Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M147.49,151.24a3.16,3.16,0,1,0,3.16,3.16A3.16,3.16,0,0,0,147.49,151.24Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M147.6,151.35a3.16,3.16,0,1,0,3.16,3.16A3.16,3.16,0,0,0,147.6,151.35Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M147.71,151.45a3.17,3.17,0,1,0,3.16,3.17A3.17,3.17,0,0,0,147.71,151.45Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.81,151.56a3.17,3.17,0,1,0,3.17,3.17A3.17,3.17,0,0,0,147.81,151.56Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M147.92,151.67a3.17,3.17,0,1,0,3.17,3.16A3.17,3.17,0,0,0,147.92,151.67Z",
    transform: "translate(-15.54 -67.02)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.25,114A36.78,36.78,0,1,0,136,150.73,36.78,36.78,0,0,0,99.25,114Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M99.25,92.39a58.34,58.34,0,1,0,58.34,58.34A58.4,58.4,0,0,0,99.25,92.39ZM51.78,157.64a4,4,0,1,1,4-4A4,4,0,0,1,51.78,157.64Zm47.47,29.87A36.78,36.78,0,1,1,136,150.73,36.78,36.78,0,0,1,99.25,187.51Zm47.47-29.87a4,4,0,1,1,4-4A4,4,0,0,1,146.72,157.64Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.59,197.72l1.18-.29-1.67-1.49Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.16,128.39q-.34.63-.66,1.29l1.67,0Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77,189.76l-3,2.58c.73.44,1.46.84,2.21,1.24Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.58,199l-1.06-3.33L98.29,199h.17C99.17,199,99.88,199,100.58,199Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.43,119.38l.37.35c1.23,1.16,2.38,2.35,3.42,2.31a2.38,2.38,0,0,0,1.73-.76,2.23,2.23,0,0,0,.65-1.76c-.08-.85-.5-1.4-2.54-3.33a3.58,3.58,0,0,1-.28-.26A45.46,45.46,0,0,0,62.43,119.38Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.53,192.65,86.08,192l-.94,3.53,2.45.65a1.83,1.83,0,1,0,.94-3.52Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.81,113.16l2.76,2,.58-1.82c-.57-.45-1.15-.89-1.74-1.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.54,110.81a1.64,1.64,0,0,0,2.3-.94,1.61,1.61,0,0,0-1.07-2.22l-2.62-1-1.23,3.16Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.56,153.63a3.15,3.15,0,0,1,2.87-3.13,47.79,47.79,0,0,0-3.49-17.45l-4.15,6.1-1.34-2.84,4.18-5.89-2.69-.71-3.76,1.77L134,129l5.6-2.63a47.4,47.4,0,0,0-5.06-6.94c-1.61,1.35-2.1,1.93-2.22,2.72a2.15,2.15,0,0,0,.55,1.78,2.56,2.56,0,0,0,2,1l-.24,2.52a5.1,5.1,0,0,1-2.08-.6,5.47,5.47,0,0,1-1.57-1.32,5.14,5.14,0,0,1-1.23-3.86c.18-1.75,1.36-2.87,2.91-4.17-.82-.84-1.68-1.65-2.56-2.43l-1.91,6.5L126,119.89l.8-2.45-4-2.91L120.73,116l-2.26-1.67,5.7-3.79q-1.87-1.2-3.87-2.22l.06.13a3.28,3.28,0,0,1-.07,2.53c-.87,2.26-3,3.1-5.37,2.16l-5.38-2.09L111.9,105a47.91,47.91,0,0,0-11.55-1.88l-.61,1.25.1,5.66-2.68,0-.1-5.66-.69-1.29a47.48,47.48,0,0,0-6.23.68l.32,1.14-5.24,1.47.9,3.23,6.16-1.72.65,2.31-8.76,2.45-1.9-6.81c-1,.37-2,.78-3,1.22l3.62,6-2.06,1.24-7.91-3.88-.58.37,3.8,6.33-2.31,1.39-3.72-6.19q-1.16.85-2.25,1.77l.28.26c1.44,1.36,3,2.66,3.06,4.78a5,5,0,0,1-1.45,3.75A5.11,5.11,0,0,1,66,124.62c-2.09,0-3.69-1.61-4.8-2.66l-.54-.5c-.56.72-1.11,1.45-1.63,2.21L65.64,127l-1.21,2.41-6.86-3.44-.09.16,3.26,4.38-.82,1.63-5.56,0-.06.13,6.94,3.48L60,138.14l-6.73-3.37a48.12,48.12,0,0,0-2.83,16,3.17,3.17,0,1,1,.33,5.87,47.52,47.52,0,0,0,3.86,14l.7-.41.48-.29c2.39-1.38,3.49-1.68,5-1.3A5,5,0,0,1,64,171.19a5.72,5.72,0,0,1,.78,2.13,5.47,5.47,0,0,1-.23,2.35L62.09,175a3.83,3.83,0,0,0,.2-1.61,3,3,0,0,0-.36-1,2.25,2.25,0,0,0-1.52-1.15,2,2,0,0,0-1.24.11,21.64,21.64,0,0,0-2.45,1.26l-.34.19-.54.32c.37.71.75,1.4,1.15,2.09l1.59-.93,2.58,4.45-1.35.78c.6.81,1.21,1.59,1.85,2.35L67,176.35,69,178.24l-5.5,5.61a47,47,0,0,0,3.44,3.33l5.48-5.59,1.91,1.87L69,188.89c.92.72,1.86,1.41,2.83,2.06l6.25-5.28,1.84,1.05-1.38,8c1.2.54,2.41,1.05,3.66,1.5L84.1,189l5.22,1.39a4.18,4.18,0,0,1,3.24,5.24,3.68,3.68,0,0,1-1.85,2.4,3.11,3.11,0,0,1-.62.28,48.33,48.33,0,0,0,5.55.65l2.83-7.38,2.11,0,2.5,7.2c1.3-.12,2.59-.3,3.87-.53l-1.87-6.75,2.32-.65,6.35,5.66.81-.28-1.89-6.83,2.59-.72,1.82,6.58a46.82,46.82,0,0,0,5.66-2.85l-2.36-3.92-3.09,1.87-1.24-2.06,8.48-5.12,1.24,2.06-3.09,1.86L125,191a47.65,47.65,0,0,0,5.17-4l-4.75-4.66,6.36-6.49,1.72,1.68L129,182.13l2.31,2.27,3.81-3.89.66.64c.85-1.06,1.67-2.15,2.43-3.28l-5.61-3.21,4.51-7.89,2.09,1.19-3.18,5.55,2.81,1.61,2.71-4.73.63.36a47.71,47.71,0,0,0,3.89-14A3.16,3.16,0,0,1,143.56,153.63Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.77,108.25c-.39.2-.79.39-1.17.6l2.17,1.06Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M72.29,110.84l.58-.37-1.14-.56Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M62.6,188.13a2.31,2.31,0,0,0,3.5-.13l.8-.82a47,47,0,0,1-3.44-3.33l-.78.8A2.28,2.28,0,0,0,62.6,188.13Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M76,195l.27-1.38c-.75-.4-1.48-.8-2.21-1.24l-1,.91Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M61.23,115a2.28,2.28,0,0,0-.66,1.78c.06.82.81,1.64,1.86,2.65a45.46,45.46,0,0,1,3.35-3.45c-1.44-1.33-2.07-1.71-2.83-1.73A2.22,2.22,0,0,0,61.23,115Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M126.41,112.06c.59.42,1.17.86,1.74,1.31l1-3.22Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M57.48,126.09l.09-.16-.33-.16Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M54.3,132.25l.06-.13h-.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M53.67,175.1a2.2,2.2,0,0,0,.25,1.85,2.38,2.38,0,0,0,3.52.79l.42-.24-1.22-2.12.35-.2c-.4-.69-.78-1.38-1.15-2.09C54.39,174,53.89,174.43,53.67,175.1Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M99.25,91.55a59.19,59.19,0,1,0,59.19,59.18A59.19,59.19,0,0,0,99.25,91.55Zm44.41,80-2.7,4.73,2.91,1.67,3.18-5.56,2.08,1.2-4.51,7.89-6.37-3.64c-.76,1.13-1.58,2.22-2.43,3.28l1.06,1-3.81,3.89,2.39,2.35,4.48-4.57,1.72,1.68-6.37,6.5-5.1-5a47.65,47.65,0,0,1-5.17,4l3.55,5.88-2.31,1.39-3.52-5.85a46.82,46.82,0,0,1-5.66,2.85l1.86,6.72-2.31.64-5.86-5.21-1.18.29,1.77,6.38-2.6.72L107,198.27c-1.28.23-2.57.41-3.87.53l2.31,6.69-2.81-.05-.77-2.46-4.91-.08L96,205.33l-2.81,0,2.42-6.35a48.33,48.33,0,0,1-5.55-.65,5.66,5.66,0,0,1-.9.18L90.63,205l-3-.8-1.18-6-1.87-.5L83.14,203l-2.61-.7,1.64-6.12c-1.25-.45-2.46-1-3.66-1.5l-1.12,6.52L75,199.81l.51-2.53-4.26-2.44-1.93,1.71-2.44-1.4,5-4.2c-1-.65-1.91-1.34-2.83-2.06l-1,1.05a5.08,5.08,0,0,1-7.25-7.11l1-1c-.64-.76-1.25-1.54-1.85-2.35l-.36.21c-1.82,1.05-3,1.31-4.3,1a5.41,5.41,0,0,1-3.87-6.52A4.29,4.29,0,0,1,52.67,172a22,22,0,0,1,2-1.35,47.52,47.52,0,0,1-3.86-14,3.15,3.15,0,0,1-.33-5.87,48.12,48.12,0,0,1,2.83-16L47.7,132l1.19-2.38,6.61.1q.31-.66.66-1.29l-4-5.24,1.19-2.37,5.77,2.89c.52-.76,1.07-1.49,1.63-2.21v0c-2-1.88-2.61-2.85-2.67-4.37a5.35,5.35,0,0,1,5.11-5.44c1.39,0,2.63.58,4.25,2.11l.43.4q1.09-.92,2.25-1.77l-3.39-5.64,2.06-1.24,6.87,3.36c.38-.21.78-.4,1.17-.6l-3.36-5.58,2.31-1.39,3.5,5.81c1-.44,2-.85,3-1.22l-1.81-6.48,8.75-2.45.65,2.32L83.7,101l.87,3.11,5.25-1.46.32,1.17a47.48,47.48,0,0,1,6.23-.68l-3.6-6.78,2.92,0,2.68,5.52,2.44-5.61,2.93-.06-3.39,7A47.91,47.91,0,0,1,111.9,105l2.64-6.8,5.16,2c2.42.94,3.44,2.91,2.6,5.08a3.12,3.12,0,0,1-2.65,2.11,4.21,4.21,0,0,1,.65.94q2,1,3.87,2.22l6.53-4.34,1.7,1.25-2.22,7.6c.88.78,1.74,1.59,2.56,2.43l.47-.39.43-.36c2.12-1.75,3.16-2.23,4.67-2.1a5.06,5.06,0,0,1,3.55,1.92,5.13,5.13,0,0,1,1,1.8,4.84,4.84,0,0,1,.19,2.15l-2.51-.23a2.57,2.57,0,0,0-.55-2.19,2.2,2.2,0,0,0-1.65-.87c-1,0-2.12.87-3.14,1.71l-.57.47-.08.07a47.4,47.4,0,0,1,5.06,6.94l6.89-3.25,1.15,2.44-5.44,2.56,7.52,1.84,1.39,3-6.91-1.8-1.29,1.89a47.79,47.79,0,0,1,3.49,17.45,2.85,2.85,0,0,1,.29,0,3.17,3.17,0,1,1,0,6.33,2.56,2.56,0,0,1-.62-.07,47.71,47.71,0,0,1-3.89,14Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M118.63,102.36l-2.45-1-1.16,3,2.46.95a1.6,1.6,0,1,0,1.15-3Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M101.13,200.7l-.55-1.72c-.7,0-1.41.05-2.12.05h-.17l-.59,1.62Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M114.56,196.25l-.81.28,1.17,1Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.56,196.26l-.81.27,1.17,1Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.23,115a2.28,2.28,0,0,0-.66,1.78c.06.82.81,1.65,1.86,2.65,1.06-1.2,2.17-2.35,3.35-3.45-1.44-1.33-2.07-1.71-2.83-1.73A2.22,2.22,0,0,0,61.23,115Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.63,102.36l-2.45-1-1.16,3,2.46.95a1.6,1.6,0,1,0,1.15-3Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.13,200.7l-.55-1.72c-.7,0-1.41.05-2.12.05h-.17l-.59,1.62Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.67,175.1a2.2,2.2,0,0,0,.25,1.85,2.38,2.38,0,0,0,3.52.79l.42-.24-1.22-2.12.35-.21c-.4-.68-.78-1.38-1.14-2.08C54.39,174,53.89,174.43,53.67,175.1Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.6,188.13a2.31,2.31,0,0,0,3.5-.13l.81-.82a45.2,45.2,0,0,1-3.45-3.33l-.78.8A2.28,2.28,0,0,0,62.6,188.13Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76,195l.27-1.39c-.75-.39-1.48-.8-2.21-1.23l-1,.91Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.48,126.09l.1-.16-.34-.16Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.25,114.8a35.94,35.94,0,1,0,35.94,35.93A36,36,0,0,0,99.25,114.8Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.41,112.06c.59.42,1.17.86,1.74,1.31l1-3.22Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.29,110.84l.58-.37-1.14-.56Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.3,132.25l.06-.13h-.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M56.16,128.39c-.23.43-.44.86-.66,1.29l1.67,0Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M88.53,192.65,86.08,192l-.94,3.53,2.45.65a1.83,1.83,0,1,0,.94-3.52Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M77,189.76l-3,2.58c.73.43,1.46.84,2.21,1.23Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M124.81,113.16l2.76,2,.58-1.82c-.57-.45-1.15-.89-1.74-1.31Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M62.43,119.38l.37.35c1.23,1.16,2.38,2.35,3.42,2.31a2.38,2.38,0,0,0,1.73-.76,2.23,2.23,0,0,0,.65-1.76c-.08-.85-.5-1.4-2.54-3.33l-.28-.26C64.6,117,63.49,118.18,62.43,119.38Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M109.59,197.72l1.18-.29-1.67-1.49Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M76.77,108.25c-.39.2-.79.39-1.17.6l2.17,1.06Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M143.56,153.63a3.15,3.15,0,0,1,2.87-3.13,47.79,47.79,0,0,0-3.49-17.45l-4.15,6.1-1.34-2.84,4.18-5.89-2.69-.71-3.76,1.77L134,129l5.6-2.64a47.11,47.11,0,0,0-5.06-6.93c-1.61,1.34-2.1,1.93-2.22,2.72a2.15,2.15,0,0,0,.55,1.78,2.56,2.56,0,0,0,2,1l-.24,2.52a5.1,5.1,0,0,1-2.08-.6,5.47,5.47,0,0,1-1.57-1.32,5.14,5.14,0,0,1-1.23-3.86c.18-1.75,1.36-2.87,2.91-4.17-.82-.84-1.68-1.66-2.56-2.44l-1.91,6.51L126,119.89l.8-2.45-4-2.91L120.73,116l-2.26-1.67,5.7-3.8q-1.87-1.19-3.87-2.21l.06.13a3.28,3.28,0,0,1-.07,2.53c-.87,2.26-3,3.1-5.37,2.16l-5.38-2.09L111.9,105a47.91,47.91,0,0,0-11.55-1.88l-.61,1.25.1,5.66-2.68,0-.1-5.66-.69-1.29a47.48,47.48,0,0,0-6.23.68l.32,1.14-5.24,1.47.9,3.23,6.16-1.72.65,2.31-8.76,2.45-1.9-6.81c-1,.37-2,.78-3,1.22l3.62,6-2.06,1.24-7.91-3.88-.58.37,3.8,6.33-2.31,1.39-3.71-6.18c-.78.56-1.53,1.15-2.26,1.76l.28.26c1.44,1.36,3,2.66,3.06,4.78a5,5,0,0,1-1.45,3.75A5.11,5.11,0,0,1,66,124.62c-2.09,0-3.69-1.61-4.8-2.66l-.54-.5c-.56.72-1.11,1.46-1.63,2.21L65.64,127l-1.21,2.41-6.85-3.44-.1.16,3.26,4.38-.82,1.63-5.56,0-.06.13,6.94,3.48L60,138.14l-6.72-3.37a47.87,47.87,0,0,0-2.83,16,3.09,3.09,0,0,1,1.29-.29,3.17,3.17,0,1,1-1,6.16,47.82,47.82,0,0,0,3.86,14l.7-.41.48-.29c2.39-1.38,3.49-1.68,5-1.3A5,5,0,0,1,64,171.19a5.72,5.72,0,0,1,.78,2.13,5.47,5.47,0,0,1-.23,2.35L62.09,175a3.83,3.83,0,0,0,.2-1.61,3,3,0,0,0-.36-1,2.25,2.25,0,0,0-1.52-1.15,2,2,0,0,0-1.24.11,21.64,21.64,0,0,0-2.45,1.26l-.34.19-.53.32c.36.7.74,1.4,1.14,2.08l1.59-.92,2.58,4.45-1.35.78c.6.8,1.21,1.59,1.86,2.35L67,176.35,69,178.24l-5.5,5.61a45.2,45.2,0,0,0,3.45,3.33l5.47-5.59,1.91,1.87L69,188.89c.92.71,1.85,1.41,2.83,2.06l6.24-5.28,1.84,1.05-1.38,8c1.2.54,2.41,1.05,3.66,1.5L84.1,189l5.22,1.39a4.18,4.18,0,0,1,3.24,5.24,3.68,3.68,0,0,1-1.85,2.4,3.11,3.11,0,0,1-.62.28,48.33,48.33,0,0,0,5.55.65l2.83-7.38,2.11,0,2.5,7.21q2-.19,3.87-.54l-1.87-6.75,2.32-.65,6.35,5.66.81-.27-1.89-6.84,2.59-.72,1.82,6.58a46.82,46.82,0,0,0,5.66-2.85l-2.36-3.92-3.09,1.87-1.24-2.06,8.48-5.12,1.24,2.06-3.09,1.86L125,191a47.65,47.65,0,0,0,5.17-4l-4.75-4.66,6.36-6.49,1.72,1.68L129,182.13l2.31,2.27,3.81-3.89.66.64c.85-1.06,1.67-2.15,2.43-3.28l-5.61-3.21,4.51-7.89,2.09,1.19-3.18,5.55,2.81,1.61,2.71-4.73.63.36a47.71,47.71,0,0,0,3.89-14A3.16,3.16,0,0,1,143.56,153.63Zm-44.31,33a35.94,35.94,0,1,1,35.94-35.94A36,36,0,0,1,99.25,186.67Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M100.58,199l-1.06-3.33L98.29,199h.17C99.17,199,99.88,199,100.58,199Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M115.54,110.81a1.64,1.64,0,0,0,2.3-.94,1.61,1.61,0,0,0-1.07-2.22l-2.62-1-1.23,3.16Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.25,114A36.78,36.78,0,1,0,136,150.73,36.78,36.78,0,0,0,99.25,114Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M99.25,92.39a58.34,58.34,0,1,0,58.34,58.34A58.4,58.4,0,0,0,99.25,92.39Zm48.42,33.21-5.44,2.56,7.52,1.84,1.39,3-6.91-1.8-5.44,8-1.34-2.84,4.18-5.89-2.69-.71-3.76,1.77L134,129l12.49-5.88ZM136,150.73A36.78,36.78,0,1,1,99.25,114,36.78,36.78,0,0,1,136,150.73Zm-2.39-34c2.12-1.75,3.16-2.23,4.67-2.1a5.06,5.06,0,0,1,3.55,1.92,5.13,5.13,0,0,1,1,1.8,4.84,4.84,0,0,1,.19,2.15l-2.51-.23a2.57,2.57,0,0,0-.55-2.19,2.2,2.2,0,0,0-1.65-.87c-1,0-2.12.87-3.14,1.71l-.57.47c-1.68,1.4-2.18,2-2.3,2.79a2.15,2.15,0,0,0,.55,1.78,2.56,2.56,0,0,0,2,1l-.24,2.52a5.1,5.1,0,0,1-2.08-.6,5.47,5.47,0,0,1-1.57-1.32,5.14,5.14,0,0,1-1.23-3.86c.19-1.92,1.6-3.09,3.38-4.56Zm-1.24-9.28-4.13,14.1L126,119.89l.8-2.45-4-2.91L120.73,116l-2.26-1.67,12.23-8.13Zm-17.86-9.27,5.16,2c2.42.94,3.44,2.91,2.6,5.08a3.12,3.12,0,0,1-2.65,2.11,3.63,3.63,0,0,1,.71,1.07,3.28,3.28,0,0,1-.07,2.53c-.87,2.26-3,3.1-5.37,2.16l-5.38-2.09Zm-18.85-1.9,2.68,5.52,2.44-5.61,2.93-.06-4,8.22.1,5.66-2.68,0-.1-5.66-4.29-8.07Zm-6.48.65.65,2.32L83.7,101l.87,3.11,5.25-1.46.64,2.31-5.24,1.47.9,3.23,6.16-1.72.65,2.31-8.76,2.45L80.46,99.39Zm-20.48,8.55,9,4.42-4.36-7.24,2.31-1.39,7.12,11.83-2.06,1.24-9-4.44,4.36,7.26-2.31,1.39-7.11-11.83Zm-9.25,7.81a5.09,5.09,0,0,1,3.65-1.67c1.39,0,2.63.58,4.25,2.11l.71.66c1.44,1.36,3,2.66,3.06,4.78a5,5,0,0,1-1.45,3.75A5.11,5.11,0,0,1,66,124.62c-2.09,0-3.69-1.61-4.8-2.66l-.55-.52c-2-1.88-2.61-2.85-2.67-4.37A5.09,5.09,0,0,1,59.48,113.3ZM48.89,129.58l8.28.12-5.06-6.55,1.19-2.37L65.64,127l-1.21,2.41-7.19-3.6,3.5,4.7-.82,1.63-5.87,0,7.19,3.6L60,138.14,47.7,132Zm-.27,24a3.16,3.16,0,1,1,3.16,3.17A3.17,3.17,0,0,1,48.62,153.63Zm6.53,27.07a5.41,5.41,0,0,1-3.87-6.52A4.29,4.29,0,0,1,52.67,172a23.5,23.5,0,0,1,2.7-1.76l.48-.29c2.39-1.38,3.49-1.68,5-1.3A5,5,0,0,1,64,171.19a5.72,5.72,0,0,1,.78,2.13,5.47,5.47,0,0,1-.23,2.35L62.09,175a3.83,3.83,0,0,0,.2-1.61,3,3,0,0,0-.36-1,2.25,2.25,0,0,0-1.52-1.15,2,2,0,0,0-1.24.11,21.64,21.64,0,0,0-2.45,1.26l-.34.19c-1.88,1.09-2.46,1.59-2.71,2.33a2.2,2.2,0,0,0,.25,1.85,2.38,2.38,0,0,0,3.52.79l.42-.24-1.22-2.12,1.94-1.13,2.58,4.45-1.71,1C57.63,180.74,56.48,181,55.15,180.7Zm5.77,9.15a4.81,4.81,0,0,1-.23-7L67,176.35,69,178.24l-6.28,6.41a2.28,2.28,0,0,0-.08,3.48,2.31,2.31,0,0,0,3.5-.13l6.28-6.41,1.91,1.87-6.35,6.48A4.8,4.8,0,0,1,60.92,189.85Zm16.47,11.36L75,199.81l.51-2.53-4.26-2.44-1.93,1.71-2.44-1.4,11.22-9.48,1.84,1.05Zm15.17-5.6a3.68,3.68,0,0,1-1.85,2.4,3.64,3.64,0,0,1-1.52.46L90.63,205l-3-.8-1.18-6-1.87-.5L83.14,203l-2.61-.7L84.1,189l5.22,1.39A4.18,4.18,0,0,1,92.56,195.61Zm10,9.83-.77-2.46-4.91-.08L96,205.33l-2.81,0,5.25-13.73,2.11,0,4.81,13.89Zm14-2.8-7.53-6.7,2.26,8.16-2.6.72-3.68-13.3,2.32-.65,7.52,6.69-2.25-8.14,2.59-.72,3.68,13.3Zm9.63-4.36-5.88-9.77-3.09,1.87-1.24-2.06,8.48-5.12,1.24,2.06-3.09,1.86,5.89,9.77Zm9-6.24-9.85-9.67,6.36-6.49,1.72,1.68L129,182.13l2.31,2.27,3.81-3.89,1.72,1.68-3.81,3.89,2.39,2.35,4.48-4.57,1.72,1.68Zm9.33-10.53-12-6.85,4.51-7.89,2.09,1.19-3.18,5.55,2.81,1.61,2.71-4.73,2.08,1.19-2.7,4.73,2.91,1.67,3.18-5.56,2.08,1.2Zm2.1-24.71a3.17,3.17,0,1,1,3.17-3.17A3.17,3.17,0,0,1,146.72,156.8Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "60.42 127.94 61.46 122.74 57.45 126.23 60.42 127.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "82.15 133.63 85.58 133.68 83.98 128.63 82.15 133.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M62.8,119.73c1.23,1.16,2.38,2.35,3.42,2.31a2.38,2.38,0,0,0,1.73-.76,2.23,2.23,0,0,0,.65-1.76c-.08-.85-.5-1.4-2.54-3.33-1.66-1.55-2.3-2-3.11-2a2.22,2.22,0,0,0-1.72.75,2.28,2.28,0,0,0-.66,1.78C60.64,117.65,61.56,118.56,62.8,119.73Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "113.65 43.13 109.26 46.14 112.03 48.17 113.65 43.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M88.53,192.65,86.08,192l-.94,3.53,2.45.65a1.83,1.83,0,1,0,.94-3.52Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M119.72,104.49a1.57,1.57,0,0,0-1.09-2.13l-2.45-1-1.16,3,2.46.95A1.57,1.57,0,0,0,119.72,104.49Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M117.84,109.87a1.61,1.61,0,0,0-1.07-2.22l-2.62-1-1.23,3.16,2.62,1A1.64,1.64,0,0,0,117.84,109.87Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M51.78,156.8a3.17,3.17,0,1,1,3.16-3.17A3.17,3.17,0,0,1,51.78,156.8Zm0-7.17a4,4,0,1,0,4,4A4,4,0,0,0,51.78,149.63Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M146.72,156.8a3.17,3.17,0,1,1,3.17-3.17A3.17,3.17,0,0,1,146.72,156.8Zm0-7.17a4,4,0,1,0,4,4A4,4,0,0,0,146.72,149.63Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M111.18,126.3c-6,0-10.18,4.08-10.18,10v14.09c0,5.87,4.17,9.95,10.18,9.95s10.15-4.08,10.15-9.95V136.25C121.33,130.38,117.15,126.3,111.18,126.3Zm4,24c0,2.73-1.59,4.51-4,4.51s-4.08-1.78-4.08-4.51V136.34c0-2.72,1.64-4.55,4.08-4.55s4,1.78,4,4.55Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M98.29,150.34a8.41,8.41,0,0,0-2-5.82A8.53,8.53,0,0,0,94,142.73a6.89,6.89,0,0,0,2.11-1.64,7.53,7.53,0,0,0,1.74-5.17c0-5.63-4.23-9.62-10.19-9.62-4.37,0-7.94,2.11-9.44,5.63a10,10,0,0,0-.8,3.9H83.5c.28-2.63,1.73-4,4.13-4a3.94,3.94,0,0,1,4.08,4.27,3.84,3.84,0,0,1-4.22,4.18H86.6v5.31h.89c2.91,0,4.69,1.74,4.69,4.6s-1.73,4.65-4.5,4.65-4.37-1.5-4.56-4.37H77c.18,2.73.65,5,2.67,7a11.25,11.25,0,0,0,7.94,2.86C94.11,160.29,98.29,156.4,98.29,150.34Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M89,164H84.31v13H89a4.71,4.71,0,0,0,3.43-1.23,4.35,4.35,0,0,0,1.16-2.26,24.47,24.47,0,0,0,.15-3v-1.15c0-2-.37-3.1-1.31-4A4.68,4.68,0,0,0,89,164ZM90.65,174a2.31,2.31,0,0,1-1.89.8H86.84V166.3h1.92a2.28,2.28,0,0,1,1.89.8c.42.54.55,1.24.55,3.17C91.2,172.69,91.09,173.38,90.65,174Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M99.11,164,94.4,177H97l.78-2.29h4.61l.76,2.29h2.64l-4.73-13Zm-.58,8.54,1.64-4.72,1.58,4.72Z",
    transform: "translate(-15.54 -67.02)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "94.21 102.25 91.79 97.02 89.04 97.02 92.94 104.67 92.94 109.98 95.45 109.98 95.45 104.67 99.35 97.02 96.6 97.02 94.21 102.25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default __webpack_public_path__ + "static/media/guarantee.b724523f96e3a629d6aade5e98328a7a.svg";
export { ForwardRef as ReactComponent };